const en = {
  dir: "ltr" as const,
  nav: {
    shopAll: "Shop All",
    contactUs: "Contact Us",
    myAccount: "My Account",
    myWishlist: "My Wishlist",
    myOrders: "My Orders",
    signIn: "Sign In",
    signOut: "Sign Out",
    createAccount: "Create Account",
    cart: "Cart",
    wishlist: "Wishlist",
    search: "Search products...",
  },
  footer: {
    tagline: "The all-in-one platform for your online business. Manage products, orders, and customers with ease.",
    shop: "Shop",
    allProducts: "All Products",
    featured: "Featured",
    onSale: "On Sale",
    support: "Support",
    faq: "FAQ",
    shippingReturns: "Shipping & Returns",
    contactUs: "Contact Us",
    admin: "Admin",
    dashboard: "Dashboard",
    manageProducts: "Manage Products",
    manageOrders: "Manage Orders",
    rights: "All rights reserved.",
    terms: "Terms",
    privacy: "Privacy",
    aboutUs: "About Us",
    pageNotFound: "Page not found",
    backToHome: "Back to Home",
  },
  contact: {
    title: "Contact Us",
    subtitle: "We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
    formTitle: "Send us a Message",
    name: "Full Name",
    namePlaceholder: "Your name",
    email: "Email Address",
    emailPlaceholder: "your@email.com",
    phone: "Phone Number (WhatsApp)",
    phonePlaceholder: "+966 5XXXXXXXX",
    subject: "Subject",
    subjectPlaceholder: "How can we help?",
    message: "Message",
    messagePlaceholder: "Tell us more about your inquiry...",
    send: "Send Message",
    sending: "Sending...",
    successTitle: "Message Sent!",
    successMessage: "Thank you for contacting us. We'll get back to you within 24 hours.",
    sendAnother: "Send another message",
    infoTitle: "Get in Touch",
    emailLabel: "Email",
    phoneLabel: "Phone",
    addressLabel: "Address",
    hoursLabel: "Business Hours",
    emailValue: "",
    phoneValue: "+966 50 000 0000",
    addressValue: "Riyadh, Saudi Arabia",
    hoursValue: "Sun - Thu: 9:00 AM - 6:00 PM",
  },
  home: {
    heroTitle: "Discover Amazing Products",
    heroSubtitle: "Shop the latest trends with unbeatable prices and fast delivery",
    shopNow: "Shop Now",
    featuredCategories: "Featured Categories",
    viewAll: "View All",
    featuredProducts: "Featured Products",
    trendingProducts: "Trending Products",
    addToCart: "Add to Cart",
    sale: "Sale",
  },
  product: {
    addToCart: "Add to Cart",
    addedToCart: "Added to cart",
    addedToCartDesc: "{qty}x {name} added to your cart.",
    viewCart: "View Cart",
    adding: "Adding...",
    addToWishlist: "Add to Wishlist",
    removeFromWishlist: "Remove from Wishlist",
    addedToWishlist: "Added to wishlist",
    removedFromWishlist: "Removed from wishlist",
    reviews: "Reviews",
    noReviews: "No reviews yet. Be the first to review this product!",
    writeReview: "Write a Review",
    yourName: "Your Name",
    rating: "Rating",
    review: "Review",
    submitReview: "Submit Review",
    reviewSubmitted: "Review submitted successfully!",
    reviewFailed: "Failed to submit review.",
    relatedProducts: "Related Products",
    description: "Description",
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    available: "available",
    quantity: "Quantity",
    sku: "SKU",
    category: "Category",
    brand: "Brand",
    compare: "Compare",
    productNotFound: "Product Not Found",
    productNotFoundDesc: "The product you're looking for doesn't exist or has been removed.",
    backToShop: "Back to Shop",
    home: "Home",
    shop: "Shop",
    securePayment: "Secure payment processing",
    returnPolicy: "30-day return policy",
    sale: "Sale",
    noImage: "No image available",
    viewProduct: "View Product",
  },
  shop: {
    title: "Shop",
    allCategories: "All Categories",
    sortBy: "Sort by",
    newest: "Newest",
    priceLowHigh: "Price: Low to High",
    priceHighLow: "Price: High to Low",
    nameAZ: "Name: A to Z",
    nameZA: "Name: Z to A",
    noProducts: "No products found",
    noProductsHint: "Try adjusting your filters or search query.",
    filters: "Filters",
    filtersDesc: "Refine your product search",
    clearFilters: "Clear All Filters",
    productsFound: "products found",
    loadingProducts: "Loading products...",
    allProducts: "All Products",
    allBrands: "All Brands",
    categories: "Categories",
    brands: "Brands",
    filterBy: "Filter By",
    featuredProducts: "Featured Products",
    newestArrivals: "Newest Arrivals",
    noImage: "No image",
    sale: "SALE",
    outOfStock: "OUT OF STOCK",
    addedToCompare: "Added to compare",
    removedFromCompare: "Removed from compare",
    addToCompare: "Add to compare",
    removeFromCompare: "Remove from compare",
    maxCompare: "Maximum {n} products can be compared",
  },
  cart: {
    title: "Shopping Cart",
    empty: "Your cart is empty",
    emptyDesc: "Looks like you haven't added any products to your cart yet.",
    continueShopping: "Continue Shopping",
    startShopping: "Start Shopping",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
    checkout: "Proceed to Checkout",
    remove: "Remove",
    quantity: "Quantity",
    product: "Product",
    price: "Price",
    qty: "Qty",
    loadingCart: "Loading cart...",
    itemRemoved: "Item removed from cart.",
    orderSummary: "Order Summary",
    shippingTax: "Shipping & Tax",
    calculatedAtCheckout: "Calculated at checkout",
    discount: "Discount",
    couponCode: "Coupon code",
    apply: "Apply",
    couponFailed: "Failed to validate coupon.",
    noImg: "No img",
  },
  checkout: {
    title: "Checkout",
    contactInfo: "Contact Information",
    fullName: "Full Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    savedAddresses: "Saved Addresses",
    newAddress: "Enter a new address",
    shippingAddress: "Shipping Address",
    address: "Address",
    city: "City",
    country: "Country",
    zipCode: "Zip Code",
    billingAddress: "Billing Address",
    sameAsShipping: "Same as shipping",
    paymentMethod: "Payment Method",
    creditCard: "Credit Card",
    paypal: "PayPal",
    placeOrder: "Place Order",
    processing: "Processing...",
    orderSummary: "Order Summary",
    subtotal: "Subtotal",
    shipping: "Shipping",
    total: "Total",
  },
  account: {
    title: "My Account",
    welcome: "Welcome",
    orders: "Orders",
    profile: "Profile",
    addresses: "Addresses",
    password: "Password",
    orderHistory: "Order History",
    orderHistoryDesc: "View your past and current orders",
    noOrders: "You haven't placed any orders yet.",
    startShopping: "Start Shopping",
    personalInfo: "Personal Information",
    personalInfoDesc: "Update your name, email, and phone",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    emailNotChange: "Email cannot be changed",
    phone: "Phone",
    saveChanges: "Save Changes",
    saving: "Saving...",
    addressBook: "Address Book",
    addressBookDesc: "Manage your shipping and billing addresses",
    addAddress: "Add Address",
    addFirstAddress: "Add Your First Address",
    noAddresses: "You haven't added any addresses yet.",
    editAddress: "Edit Address",
    addNewAddress: "Add New Address",
    label: "Label",
    labelPlaceholder: "e.g. Home, Work, Office",
    fullName: "Full Name",
    addressField: "Address",
    addressPlaceholder: "Street address, apartment, suite",
    setDefault: "Set as default address",
    updateAddress: "Update Address",
    default: "Default",
    edit: "Edit",
    delete: "Delete",
    setAsDefault: "Set Default",
    changePassword: "Change Password",
    changePasswordDesc: "Update your account password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    updatePassword: "Update Password",
    updating: "Updating...",
    returnBtn: "Return",
    view: "View",
    requestReturn: "Request a Return",
    selectItems: "Select items to return",
    returnReason: "Reason for return *",
    returnReasonPlaceholder: "Please describe the reason...",
    returnNotes: "Additional notes (optional)",
    returnNotesPlaceholder: "Any additional details...",
    cancel: "Cancel",
    submitReturn: "Submit Return Request",
    submitting: "Submitting...",
  },
  auth: {
    signIn: "Sign In",
    signInDesc: "Enter your credentials to access your account",
    email: "Email",
    password: "Password",
    signInBtn: "Sign In",
    signingIn: "Signing in...",
    noAccount: "Don't have an account?",
    createAccount: "Create Account",
    createAccountDesc: "Enter your details to create a new account",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    confirmPassword: "Confirm Password",
    register: "Create Account",
    registering: "Creating...",
    haveAccount: "Already have an account?",
  },
  wishlist: {
    title: "Wishlist",
    myWishlist: "My Wishlist",
    items: "items",
    empty: "Your wishlist is empty",
    emptyDesc: "Browse products and add your favorites!",
    signInRequired: "Please sign in to view your wishlist.",
    loading: "Loading wishlist...",
    removed: "Removed from wishlist.",
    startShopping: "Start Shopping",
    viewProduct: "View Product",
    noImage: "No image",
    sale: "Sale",
    outOfStock: "Out of Stock",
  },
  compare: {
    title: "Compare Products",
    products: "products",
    emptyDesc: "No products selected for comparison. Browse the shop and click the compare button on products you'd like to compare.",
    browseProducts: "Browse Products",
    clearAll: "Clear All",
    feature: "Feature",
    price: "Price",
    rating: "Rating",
    category: "Category",
    brand: "Brand",
    sku: "SKU",
    availability: "Availability",
    weight: "Weight",
    description: "Description",
    action: "Action",
    viewProduct: "View Product",
    inStock: "In Stock",
    outOfStock: "Out of Stock",
    noImage: "No image",
    loading: "Loading comparison...",
    selectedForComparison: "selected for comparison",
    clear: "Clear",
    compareNow: "Compare Now",
    productSelected: "product",
    productsSelected: "products",
    kg: "kg",
  },
  orderConfirmation: {
    thankYou: "Thank you for your order!",
    receivedOrder: "We've received your order and will contact you as soon as your package is shipped.",
    orderNumber: "Order Number",
    orderDetails: "Order Details",
    subtotal: "Subtotal",
    discount: "Discount",
    shipping: "Shipping",
    tax: "Tax",
    total: "Total",
    shippingAddress: "Shipping Address",
    paymentMethod: "Payment Method",
    paymentStatus: "Status",
    printInvoice: "Print Invoice",
    continueShopping: "Continue Shopping",
    orderNotFound: "Order Not Found",
    returnToHome: "Return to Home",
    loadingOrder: "Loading order details...",
  },
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    backToHome: "Back to Home",
    viewOrder: "View Order",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    edit: "Edit",
    actions: "Actions",
    active: "Active",
    inactive: "Inactive",
    disabled: "Disabled",
    email: "Email",
    status: "Status",
    noData: "No data available",
    confirmDelete: "Are you sure you want to delete?",
    yes: "Yes",
    no: "No",
    search: "Search",
    all: "All",
    previous: "Previous",
    next: "Next",
  },
  admin: {
    title: "Admin Dashboard",
    signedInAs: "Signed in as",
    backToStore: "Back to Store",
    signOut: "Sign Out",
    sidebar: {
      dashboard: "Dashboard",
      products: "Products",
      categories: "Categories",
      orders: "Orders",
      customers: "Customers",
      coupons: "Coupons",
      banners: "Banners",
      returns: "Returns",
      brands: "Brands",
      settings: "Settings",
    },
    login: {
      title: "Admin Login",
      subtitle: "Sign in to access the admin panel",
      username: "Username",
      identifier: "Username, email, or phone",
      identifierPlaceholder: "admin / you@example.com / +9665xxxxxxxx",
      identifierHint: "Sign in with your username, email address, or WhatsApp/phone number.",
      password: "Password",
      tabUsername: "Username",
      tabEmail: "Email",
      tabWhatsapp: "WhatsApp",
      emailLabel: "Email address",
      emailHint: "We'll send a 4-digit verification code to your inbox.",
      whatsappLabel: "WhatsApp number",
      whatsappHint: "We'll send a 4-digit verification code on WhatsApp. e.g. 05xxxxxxxx or +9665xxxxxxxx",
      sendCode: "Send verification code",
      sendingCode: "Sending…",
      otpSentEmail: "Code sent to your email",
      otpSentWhatsapp: "Code sent on WhatsApp",
      otpSentDesc: "Open the message and copy the 4 digits.",
      codeSentTo: "We sent the code to:",
      codeLabel: "Verification code (4 digits)",
      verifyAndSignIn: "Verify & sign in",
      verifying: "Verifying…",
      resendCode: "Resend code",
      resendIn: "Resend in",
      changeIdentifier: "Change address",
      forgotPassword: "Forgot password?",
      signIn: "Sign In",
      signingIn: "Signing in...",
      welcome: "Welcome!",
      welcomeDesc: "You are now logged in as admin.",
      loginFailed: "Login failed",
    },
    dashboard: {
      title: "Dashboard",
      welcomeMsg: "Welcome back. Here's what's happening with your store today.",
      totalRevenue: "Total Revenue",
      orders: "Orders",
      customers: "Customers",
      products: "Products",
      today: "today",
      pending: "pending",
      lowStock: "low in stock",
      revenueOverview: "Revenue Overview",
      pastWeek: "Current Week",
      pastMonth: "Current Month",
      pastQuarter: "Last 3 Months",
      pastYear: "Current Year",
      orderStatus: "Order Status",
      orderStatusDesc: "Current state of all orders",
      recentOrders: "Recent Orders",
      viewAll: "View All",
      noRecentOrders: "No recent orders.",
      topProducts: "Top Products",
      sold: "sold",
      noSalesData: "No sales data yet.",
      onlineNow: "Online Now",
      totalSales: "Total Sales",
      totalOrders: "Total Orders",
      totalAbandonedCarts: "Total Abandoned Carts",
      more: "More..",
      viewMore: "View more..",
      periodToday: "Today",
      periodWeek: "This Week",
      periodMonth: "This Month",
      periodYear: "This Year",
      latestOrders: "Latest Orders",
      latestActivity: "Latest Activity",
      orderNumber: "Order #",
      customerName: "Customer Name",
      status: "Status",
      orderDate: "Order Date",
      total: "Total",
      edit: "Edit",
      noActivity: "No recent activity.",
    },
    products: {
      title: "Products",
      addProduct: "Add Product",
      exportCsv: "Export CSV",
      importCsv: "Import CSV",
      searchProducts: "Search products...",
      image: "Image",
      name: "Name",
      sku: "SKU",
      price: "Price",
      stock: "Stock",
      status: "Status",
      actions: "Actions",
      edit: "Edit",
      delete: "Delete",
      openMenu: "Open menu",
      loadingProducts: "Loading products...",
      noProducts: "No products found.",
      deleteConfirm: "Are you sure you want to delete this product?",
      deleted: "Product deleted successfully.",
      deleteFailed: "Failed to delete product.",
      exported: "Products exported successfully.",
      exportFailed: "Failed to export products.",
      importTitle: "Import Products from CSV",
      importDesc: "Upload a CSV file to import products. Use the same format as the export. Products with existing IDs will be updated. New rows will be created.",
      importing: "Importing products...",
      imported: "Imported",
      updated: "Updated",
      failed: "Failed",
      importFailed: "Failed to import products.",
      noImg: "No img",
    },
    productEdit: {
      createTitle: "Create Product",
      editTitle: "Edit Product",
      nameEn: "Name (EN)",
      nameAr: "Name (AR)",
      nameArPlaceholder: "اسم المنتج بالعربية",
      skuLabel: "SKU",
      priceLabel: "Price",
      salePrice: "Sale Price (Optional)",
      costPrice: "Cost Price (Optional)",
      quantityInStock: "Quantity in Stock",
      category: "Category",
      selectCategory: "Select a category",
      brand: "Brand",
      selectBrand: "Select a brand",
      noBrand: "No brand",
      statusLabel: "Status",
      selectStatus: "Select status",
      shortDescEn: "Short Description (EN)",
      shortDescAr: "Short Description (AR)",
      shortDescArPlaceholder: "الوصف المختصر بالعربية",
      fullDescEn: "Full Description (EN)",
      fullDescAr: "Full Description (AR)",
      fullDescArPlaceholder: "الوصف الكامل بالعربية",
      productImage: "Product Image",
      featuredProduct: "Featured Product",
      featuredDesc: "This product will appear on the homepage.",
      cancel: "Cancel",
      saveProduct: "Save Product",
      created: "Product created successfully.",
      updated: "Product updated successfully.",
      createFailed: "Failed to create product.",
      updateFailed: "Failed to update product.",
    },
    categories: {
      title: "Categories",
      categoryList: "Category List",
      addCategory: "Add Category",
      editCategory: "Edit Category",
      newCategory: "New Category",
      nameEn: "Name (EN)",
      nameAr: "Name (AR)",
      nameArPlaceholder: "اسم الفئة بالعربية",
      descEn: "Description (EN)",
      descAr: "Description (AR)",
      descArPlaceholder: "الوصف بالعربية",
      categoryImage: "Category Image",
      sortOrder: "Sort Order",
      image: "Image",
      name: "Name",
      categoryName: "Category Name",
      parentCategory: "Parent Category",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      allStatuses: "All",
      noParent: "None (Top Level)",
      filter: "Filter",
      productsCount: "Products",
      actions: "Actions",
      edit: "Edit",
      categoryUpdated: "Category updated",
      categoryCreated: "Category created",
      saveFailed: "Failed to save category",
      categoryDeleted: "Category deleted",
      selectAll: "Select All",
      deleteSelected: "Delete Selected",
      selectedCount: "selected",
      noCategories: "No categories found",
      noCategoriesHint: "Try adjusting your filters or add a new category.",
      breadcrumbHome: "Home",
      breadcrumbCategories: "Categories",
    },
    orders: {
      title: "Orders",
      filterByStatus: "Filter by status",
      allOrders: "All Orders",
      pending: "Pending",
      processing: "Processing",
      shipped: "Shipped",
      delivered: "Delivered",
      cancelled: "Cancelled",
      refunded: "Refunded",
      orderNumber: "Order #",
      date: "Date",
      customer: "Customer",
      status: "Status",
      payment: "Payment",
      total: "Total",
      actions: "Actions",
      loadingOrders: "Loading orders...",
      noOrders: "No orders found.",
      paymentPending: "Pending",
      paymentPaid: "Paid",
      paymentFailed: "Failed",
      paymentRefunded: "Refunded",
      filter: "Filter",
      filterOrders: "Filter Orders",
      orderStatus: "Order Status",
      minTotal: "Min Total",
      maxTotal: "Max Total",
      dateAdded: "Date Added",
      dateModified: "Date Modified",
      customerName: "Customer",
      email: "Email",
      paymentMethod: "Payment",
      deliveryMethod: "Delivery",
      region: "Region",
      city: "City",
      phone: "Phone",
      edit: "Edit",
      updateSelected: "Update Selected Orders",
    },
    orderDetail: {
      order: "Order",
      printInvoice: "Print Invoice",
      items: "Items",
      paymentSummary: "Payment Summary",
      subtotal: "Subtotal",
      shipping: "Shipping",
      tax: "Tax",
      discount: "Discount",
      total: "Total",
      paymentStatus: "Payment Status",
      orderStatus: "Order Status",
      customerTitle: "Customer",
      shippingAddress: "Shipping Address",
      orderNotFound: "Order not found.",
      customerDetails: "Customer Details",
      orderDetails: "Order Details",
      orderDate: "Order Date",
      paymentMethodLabel: "Payment Method",
      shippingMethodLabel: "Shipping Method",
      sku: "SKU",
      productName: "Product",
      quantity: "Qty",
      unitPrice: "Unit Price",
      subtotalBeforeTax: "Subtotal Before Tax",
      vat: "VAT",
      excise: "Excise Tax",
      orderHistory: "Order History",
      addToHistory: "Add to Order History",
      historyDate: "Date Added",
      historyNotes: "Notes",
      historyStatus: "Status",
      customerNotified: "Customer Notified",
      notifyCustomer: "Notify Customer",
      notes: "Notes",
      addToRecord: "Add to Record",
      yes: "Yes",
      no: "No",
      sms: "SMS",
      history: "History",
      additional: "Additional",
    },
    customers: {
      title: "Customers",
      searchCustomers: "Search customers...",
      name: "Name",
      email: "Email",
      phone: "Phone",
      orders: "Orders",
      totalSpent: "Total Spent",
      lastOrder: "Last Order",
      group: "Group",
      status: "Status",
      actions: "Actions",
      noCustomers: "No customers found.",
      noGroup: "No Group",
      allGroups: "All Groups",
      allStatuses: "All",
      noGroupAssigned: "Unassigned",
      filter: "Filter",
      customerList: "Customer List",
      never: "Never",
      customerName: "Customer Name",
      customerGroup: "Customer Group",
      approval: "Approval",
      registrationDate: "Registration Date",
      customerIp: "Customer IP",
      dateFrom: "From",
      dateTo: "To",
      ip: "IP",
      totalValue: "Total Value",
      edit: "Edit",
      approved: "Approved",
      notApproved: "Not Approved",
      enabled: "Enabled",
      disabled: "Disabled",
    },
    customerDetail: {
      editDetails: "Edit Details",
      eraseData: "Erase customer data",
      eraseDataTitle: "Confirm customer data erasure",
      eraseDataDescription: "At the customer's request, the name, email and phone number will be replaced with redacted tokens. All saved addresses will be permanently deleted. Past orders and their data are preserved for financial archiving. This action cannot be undone.",
      eraseDataConfirm: "Yes, erase data",
      eraseDataCancel: "Cancel",
      eraseDataSuccess: "Customer data erased and identity anonymized.",
      eraseDataFailed: "Failed to erase customer data.",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      city: "City",
      country: "Country",
      zipCode: "Zip Code",
      status: "Status",
      customerGroup: "Customer Group",
      noGroup: "No Group",
      saveChanges: "Save Changes",
      customerUpdated: "Customer updated successfully.",
      updateFailed: "Failed to update customer.",
      summary: "Summary",
      totalOrders: "Total Orders",
      totalSpent: "Total Spent",
      avgOrderValue: "Avg Order Value",
      lastOrderDate: "Last Order",
      customerSince: "Customer Since",
      customerNotFound: "Customer not found.",
      customFields: "Custom Fields",
      noCustomFields: "No custom fields defined.",
      fieldsSaved: "Custom fields saved.",
      fieldsSaveFailed: "Failed to save custom fields.",
      tabGeneral: "General",
      tabOrderHistory: "Order History",
      tabPurchasedProducts: "Purchased Products",
      tabShoppingCart: "Shopping Cart",
      tabWishlist: "Wishlist",
      tabCustomerTracking: "Customer Tracking",
      tabHistory: "History",
      tabCustomerBalance: "Customer Balance",
      tabRewardPoints: "Reward Points",
      tabIpAddress: "IP Address",
      password: "Password",
      confirmPassword: "Confirm Password",
      gender: "Gender",
      male: "Male",
      female: "Female",
      newsletter: "Newsletter",
      enabled: "Enabled",
      approval: "Approval",
      yes: "Yes",
      no: "No",
      safe: "Safe",
      note: "Note",
      orderNumber: "Order #",
      dateAdded: "Date Added",
      invoiceNo: "Invoice #",
      shippingMethod: "Shipping",
      paymentMethod: "Payment Method",
      orderStatus: "Status",
      store: "Store",
      currency: "Currency",
      products: "Products",
      total: "Total",
      shipping: "Shipping",
      tax: "Tax",
      orderTotal: "Order Total",
      totals: "Totals",
      allStatuses: "All Statuses",
      statisticRange: "Statistics Range",
      allTime: "All Time",
      startDate: "Start Date",
      endDate: "End Date",
      image: "Image",
      sku: "SKU",
      type: "Type",
      product: "Product",
      category: "Category",
      brand: "Brand",
      quantity: "Quantity",
      unitPrice: "Unit Price",
      productOptions: "Product Options",
      noResults: "No results!",
      showing: "Showing",
      to: "to",
      of: "of",
      pages: "pages",
      clearTracking: "Clear Tracking",
      scope: "Scope",
      ipAddress: "IP Address",
      page: "Page",
      pageUrl: "Page URL",
      referrer: "Referrer",
      clickCount: "Click Count",
      visitDate: "Visit Date",
      notes: "Notes",
      addToHistory: "Add to History",
      description: "Description",
      amount: "Amount",
      addBalance: "Add Customer Balance",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      confirmDelete: "Are you sure you want to delete?",
      updatedSuccessfully: "Updated successfully",
      deletedSuccessfully: "Deleted successfully",
      operationFailed: "Operation failed",
      points: "Points",
      addRewardPoints: "Add Reward Points",
      accountCount: "Account Count",
      registrationDate: "Registration Date",
      addAddresses: "Addresses",
      addAddress: "Add Address",
      editAddress: "Edit Address",
      addressLabel: "Label",
      addressLabelPh: "Home, Work…",
      addressFullName: "Full Name",
      addressPhone: "Phone",
      addressLine: "Street Address",
      addressCity: "City",
      addressCountry: "Country",
      addressZip: "ZIP / Postal Code",
      addressIsDefault: "Default Address",
      addressMakeDefault: "Set as Default",
      addressDefaultBadge: "Default",
      noAddresses: "No saved addresses for this customer",
      addressDeleted: "Address deleted",
      addressSaved: "Address saved",
    },
    customerGroups: {
      title: "Customer Groups",
      groupList: "Group List",
      addGroup: "Add Group",
      editGroup: "Edit Group",
      newGroup: "New Group",
      nameEn: "Name (EN)",
      nameAr: "Name (AR)",
      nameArPlaceholder: "اسم المجموعة بالعربية",
      descEn: "Description (EN)",
      descAr: "Description (AR)",
      descArPlaceholder: "الوصف بالعربية",
      discount: "Discount (%)",
      sortOrder: "Sort Order",
      isDefault: "Default Group",
      isDefaultHint: "New customers are automatically assigned to this group",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      name: "Name",
      customers: "Customers",
      actions: "Actions",
      groupCreated: "Group created successfully.",
      groupUpdated: "Group updated successfully.",
      groupDeleted: "Group deleted.",
      saveFailed: "Failed to save group.",
      noGroups: "No customer groups found.",
      autoAssign: "Auto-Assign",
      autoAssignTitle: "Auto-Assign Customers to Groups",
      autoAssignDesc: "Automatically assign customers to groups based on defined rules.",
      autoAssignBtn: "Run Auto-Assignment",
      autoAssignSuccess: "customers auto-assigned to groups.",
      autoAssignFailed: "Failed to run auto-assignment.",
      rules: "Rules",
      addRule: "Add Rule",
      ruleType: "Condition",
      operator: "Operator",
      value: "Value",
      deleteRule: "Delete Rule",
      ruleCreated: "Rule created.",
      ruleDeleted: "Rule deleted.",
      noRules: "No rules defined for this group.",
      ruleTypes: {
        order_count: "Number of Orders",
        total_spent: "Total Amount Spent",
        days_since_last_order: "Days Since Last Order",
        days_since_registration: "Days Since Registration",
        avg_order_value: "Average Order Value",
      },
      operators: {
        gte: "Greater than or equal (>=)",
        lte: "Less than or equal (<=)",
        gt: "Greater than (>)",
        lt: "Less than (<)",
        eq: "Equal (=)",
      },
    },
    customerFields: {
      title: "Customer Fields",
      fieldList: "Field List",
      addField: "Add Field",
      editField: "Edit Field",
      newField: "New Field",
      nameEn: "Name (EN)",
      nameAr: "Name (AR)",
      nameArPlaceholder: "اسم الخانة بالعربية",
      fieldType: "Field Type",
      options: "Options",
      optionsHint: "Comma-separated values (for select type)",
      required: "Required",
      sortOrder: "Sort Order",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      name: "Name",
      type: "Type",
      actions: "Actions",
      fieldCreated: "Field created successfully.",
      fieldUpdated: "Field updated successfully.",
      fieldDeleted: "Field deleted.",
      saveFailed: "Failed to save field.",
      noFields: "No custom fields found.",
      fieldTypes: {
        text: "Text",
        textarea: "Text Area",
        select: "Select (Dropdown)",
        checkbox: "Checkbox",
        date: "Date",
        number: "Number",
      },
    },
    coupons: {
      title: "Coupons",
      createCoupon: "Create Coupon",
      editCoupon: "Edit Coupon",
      newCoupon: "New Coupon",
      code: "Code",
      type: "Type",
      percentage: "Percentage",
      fixedAmount: "Fixed Amount",
      value: "Value",
      minOrder: "Min Order ($)",
      startDate: "Start Date",
      endDate: "End Date",
      maxUses: "Max Uses (Total)",
      status: "Status",
      discount: "Discount",
      usage: "Usage",
      validUntil: "Valid Until",
      actions: "Actions",
      couponUpdated: "Coupon updated",
      couponCreated: "Coupon created",
      couponDeleted: "Coupon deleted",
      statusExpired: "Expired",
      statusNotStarted: "Not started",
      statusUsedUp: "Usage limit reached",
      errorExpired: "Coupon has expired",
      errorNotFound: "Coupon not found",
      errorNotActive: "Coupon is not active",
      searchPlaceholder: "Search by coupon code...",
      filterAll: "All",
      filterStatus: "Status",
      filterType: "Type",
      statusActive: "Active",
      statusInactive: "Inactive",
      noResults: "No matching coupons",
      showing: "Showing",
      of: "of",
      page: "Page",
      previous: "Previous",
      next: "Next",
      sortAsc: "Ascending",
      sortDesc: "Descending",
      reset: "Reset",
      errorUsageLimit: "Coupon usage limit reached",
      errorMinAmount: "Minimum order amount is",
      appliesTo: "Applies to",
      appliesToAll: "All products",
      appliesToSpecific: "Specific categories",
      applicableCategories: "Eligible categories",
      excludedCategories: "Excluded categories",
      selectCategories: "Select categories",
      selectCategoriesExclude: "Select categories to exclude",
      noEligibleItems: "No eligible items for this coupon",
      image: "Coupon image",
      imageHelp: "Shown to the customer when the coupon is applied or on the offers page",
      uploadImage: "Upload image",
      removeImage: "Remove image",
      uploading: "Uploading…",
      descriptionAr: "Description (Arabic)",
      descriptionEn: "Description (English)",
      descriptionPlaceholderAr: "مثال: خصم خاص بمناسبة العيد",
      descriptionPlaceholderEn: "e.g. Special Eid discount",
      termsAr: "Terms of use (Arabic)",
      termsEn: "Terms of use (English)",
      termsPlaceholderAr: "مثال: لا يُجمع مع عروض أخرى — صالح لأول طلب فقط",
      termsPlaceholderEn: "e.g. Cannot be combined with other offers — first order only",
      sectionBasics: "Basics",
      sectionContent: "Content & display",
      sectionScope: "Scope",
      sectionRestrictions: "Additional restrictions",
      maxDiscountAmount: "Maximum discount amount",
      maxDiscountHelp: "Applies only to percentage discounts — leave empty for no cap",
      requiresSignIn: "Requires sign-in",
      requiresSignInHelp: "Will be rejected for guest (non-signed-in) customers",
      firstOrderOnly: "Valid for first order only",
      firstOrderOnlyHelp: "Will be rejected if the customer has any prior orders",
      customerGroups: "Eligible customer groups",
      customerGroupsHelp: "Leave empty to allow all customers",
      selectCustomerGroups: "Select groups",
      errorRequiresSignIn: "You must sign in to use this coupon",
      errorWrongGroup: "This coupon is not available for your group",
      errorFirstOrderOnly: "This coupon is valid only for the first order",
    },
    banners: {
      title: "Banners",
      addBanner: "Add Banner",
      editBanner: "Edit Banner",
      newBanner: "New Banner",
      titleEn: "Title (EN)",
      titleAr: "Title (AR)",
      titleArPlaceholder: "عنوان البانر بالعربية",
      subtitleEn: "Subtitle (EN)",
      subtitleAr: "Subtitle (AR)",
      subtitleArPlaceholder: "العنوان الفرعي بالعربية",
      bannerImage: "Banner Image",
      linkUrl: "Link URL (Optional)",
      sortOrder: "Sort Order",
      status: "Status",
      preview: "Preview",
      titleCol: "Title",
      link: "Link",
      actions: "Actions",
      bannerUpdated: "Banner updated",
      bannerCreated: "Banner created",
      bannerDeleted: "Banner deleted",
      saveFailed: "Failed to save banner",
    },
    brands: {
      title: "Brands",
      subtitle: "Manage product brands and manufacturers",
      addBrand: "Add Brand",
      editBrand: "Edit Brand",
      newBrand: "New Brand",
      nameEn: "Name (EN) *",
      nameAr: "Name (AR)",
      nameArPlaceholder: "اسم الماركة بالعربية",
      nameEnPlaceholder: "e.g. Apple, Samsung, Nike",
      descEn: "Description (EN)",
      descAr: "Description (AR)",
      descEnPlaceholder: "Brief description of the brand",
      descArPlaceholder: "وصف الماركة بالعربية",
      brandLogo: "Brand Logo",
      websiteUrl: "Website URL",
      websitePlaceholder: "https://example.com",
      cancel: "Cancel",
      update: "Update",
      create: "Create",
      logo: "Logo",
      name: "Name",
      description: "Description",
      website: "Website",
      products: "Products",
      actions: "Actions",
      visit: "Visit",
      noBrands: "No brands yet. Click \"Add Brand\" to create one.",
      brandUpdated: "Brand updated",
      brandCreated: "Brand created",
      brandDeleted: "Brand deleted",
      deleteConfirm: "Are you sure? Products will be unlinked from this brand.",
    },
    returns: {
      title: "Returns",
      subtitle: "Manage return and refund requests",
      allStatuses: "All Statuses",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      completed: "Completed",
      returnNumber: "Return #",
      orderNumber: "Order #",
      customer: "Customer",
      reason: "Reason",
      refund: "Refund",
      status: "Status",
      date: "Date",
      actions: "Actions",
      view: "View",
      loadingReturns: "Loading returns...",
      noReturns: "No return requests found",
      returnDetails: "Return Details",
      order: "Order:",
      statusLabel: "Status:",
      customerLabel: "Customer:",
      emailLabel: "Email:",
      requested: "Requested:",
      refundAmount: "Refund Amount:",
      reasonLabel: "Reason",
      customerNotes: "Customer Notes",
      itemsToReturn: "Items to Return",
      product: "Product",
      qty: "Qty",
      price: "Price",
      adminNotes: "Admin Notes",
      updateStatus: "Update Status",
      newStatus: "New Status",
      selectStatus: "Select status",
      approve: "Approve",
      reject: "Reject",
      completeRefund: "Complete (Refund)",
      refundAmountLabel: "Refund Amount ($)",
      addNotes: "Add notes about this return...",
      close: "Close",
      statusUpdated: "Return status updated successfully.",
      updateFailed: "Failed to update return status.",
      page: "Page",
      of: "of",
      total: "total",
    },
    settings: {
      title: "Store Settings",
      generalInfo: "General Information",
      storeName: "Store Name",
      logoUrl: "Logo URL",
      storeDescription: "Store Description",
      contactDetails: "Contact Details",
      supportEmail: "Support Email",
      phoneNumber: "Phone Number",
      physicalAddress: "Physical Address",
      financials: "Financials & Shipping",
      currencyCode: "Currency Code (e.g. USD)",
      currencySymbol: "Currency Symbol (e.g. $)",
      taxRate: "Tax Rate (%)",
      flatShippingRate: "Flat Shipping Rate",
      freeShippingThreshold: "Free Shipping Threshold (Optional)",
      saveSettings: "Save Settings",
      settingsUpdated: "Settings updated successfully.",
      loadingSettings: "Loading settings...",
    },
    reviews: {
      title: "Reviews",
      subtitle: "Manage product reviews and ratings",
      allStatuses: "All Statuses",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      searchReviews: "Search reviews...",
      product: "Product",
      customer: "Customer",
      rating: "Rating",
      comment: "Comment",
      status: "Status",
      date: "Date",
      actions: "Actions",
      approve: "Approve",
      reject: "Reject",
      delete: "Delete",
      noReviews: "No reviews found.",
      loadingReviews: "Loading reviews...",
      reviewApproved: "Review approved.",
      reviewRejected: "Review rejected.",
      reviewDeleted: "Review deleted.",
      deleteConfirm: "Are you sure you want to delete this review?",
      stars: "stars",
    },
    pages: {
      title: "Information Pages",
      subtitle: "Manage static content pages (About, Terms, Privacy, etc.)",
      addPage: "Add Page",
      editPage: "Edit Page",
      newPage: "New Page",
      titleEn: "Title (EN)",
      titleAr: "Title (AR)",
      titleArPlaceholder: "عنوان الصفحة بالعربية",
      slug: "Slug (URL)",
      slugPlaceholder: "e.g. about-us, terms, privacy",
      contentEn: "Content (EN)",
      contentAr: "Content (AR)",
      contentArPlaceholder: "محتوى الصفحة بالعربية",
      sortOrder: "Sort Order",
      status: "Status",
      pageName: "Page Title",
      url: "URL",
      actions: "Actions",
      pageUpdated: "Page updated successfully.",
      pageCreated: "Page created successfully.",
      pageDeleted: "Page deleted successfully.",
      saveFailed: "Failed to save page.",
      noPages: "No pages yet.",
      deleteConfirm: "Are you sure you want to delete this page?",
    },
    reports: {
      title: "Reports",
      subtitle: "Sales reports and analytics",
      salesReport: "Sales Report",
      totalSales: "Total Sales",
      totalOrders: "Total Orders",
      avgOrderValue: "Avg. Order Value",
      topSellingProducts: "Top Selling Products",
      salesByCategory: "Sales by Category",
      monthlySales: "Monthly Sales",
      month: "Month",
      revenue: "Revenue",
      orders: "Orders",
      product: "Product",
      unitsSold: "Units Sold",
      category: "Category",
      noData: "No data available for this period.",
      last30Days: "Last 30 Days",
      last90Days: "Last 90 Days",
      last12Months: "Last 12 Months",
      thisYear: "This Year",
      sales: "Sales",
      salesSubtitle: "Revenue, orders and payment analytics",
      products: "Products",
      productsSubtitle: "Product performance, stock levels and ratings",
      customers: "Customers",
      customersSubtitle: "Customer activity, registrations and spending",
      marketing: "Marketing",
      marketingSubtitle: "Coupon usage and campaign performance",
      ordersReport: "Orders",
      ordersSubtitle: "Order statuses, cities and daily trends",
      returnsReport: "Returns",
      returnsSubtitle: "Return rates, reasons and refund analytics",
      totalDiscount: "Total Discounts",
      totalShipping: "Total Shipping",
      totalTax: "Total Tax",
      byPaymentMethod: "By Payment Method",
      paymentMethod: "Payment Method",
      count: "Count",
      total: "Total",
      lowStock: "Low Stock",
      outOfStock: "Out of Stock",
      topRated: "Top Rated",
      activeProducts: "Active Products",
      avgPrice: "Avg. Price",
      stock: "Stock",
      rating: "Rating",
      reviewCount: "Reviews",
      price: "Price",
      topCustomers: "Top Customers",
      newThisMonth: "New This Month",
      newLastMonth: "New Last Month",
      noOrderCustomers: "No Order Customers",
      customerRegistrations: "Customer Registrations",
      customer: "Customer",
      email: "Email",
      totalSpent: "Total Spent",
      lastOrder: "Last Order",
      couponUsage: "Coupon Usage",
      totalCoupons: "Total Coupons",
      activeCoupons: "Active Coupons",
      totalUsed: "Total Used",
      ordersWithCoupons: "Orders With Coupons",
      totalDiscountGiven: "Total Discount Given",
      couponCode: "Coupon Code",
      type: "Type",
      value: "Value",
      used: "Used",
      maxUses: "Max Uses",
      status: "Status",
      statusBreakdown: "Status Breakdown",
      paymentStatusBreakdown: "Payment Status",
      todayOrders: "Today's Orders",
      thisMonthOrders: "This Month",
      pendingOrders: "Pending Orders",
      ordersByCity: "Orders By City",
      city: "City",
      dailyOrders: "Daily Orders (Last 30 Days)",
      totalReturns: "Total Returns",
      totalRefunded: "Total Refunded",
      pendingReturns: "Pending Returns",
      approvedReturns: "Approved Returns",
      returnRate: "Return Rate",
      thisMonthReturns: "This Month Returns",
      recentReturns: "Recent Returns",
      topReturnReasons: "Top Return Reasons",
      returnNumber: "Return #",
      reason: "Reason",
      refundAmount: "Refund Amount",
      date: "Date",
      unlimited: "Unlimited",
      noReturns: "No returns recorded yet.",
      noCoupons: "No coupons created yet.",
      couponRate: "Coupon Usage Rate",
    },
    sidebarGroups: {
      catalog: "Catalog",
      sales: "Sales",
      customers: "Customers",
      marketing: "Marketing",
      content: "Content",
      system: "Settings",
      extensions: "Extensions",
      blog: "Blog",
      reports: "Reports",
    },
    giftVouchers: {
      title: "Gift Vouchers",
      subtitle: "Create and manage gift voucher codes",
      addNew: "Add Gift Voucher",
      editVoucher: "Edit Gift Voucher",
      addDesc: "Create a new gift voucher code",
      editDesc: "Update gift voucher details",
      code: "Voucher Code",
      codeAutoGenerate: "Leave empty to auto-generate",
      from: "From",
      to: "To",
      fromName: "From Name",
      fromEmail: "From Email",
      toName: "To Name",
      toEmail: "To Email",
      amount: "Amount",
      balance: "Balance",
      status: "Status",
      date: "Date",
      theme: "Theme",
      message: "Message",
      expiresAt: "Expiry Date",
      themeGeneral: "General",
      themeBirthday: "Birthday",
      themeChristmas: "Holiday",
      themeWedding: "Wedding",
      themeThankYou: "Thank You",
      statusActive: "Active",
      statusUsed: "Used",
      statusExpired: "Expired",
      statusDisabled: "Disabled",
      created: "Gift voucher created successfully",
      updated: "Gift voucher updated successfully",
      deleted: "Gift voucher deleted",
      codeCopied: "Voucher code copied",
      noVouchers: "No gift vouchers found",
      searchPlaceholder: "Search by code, name or email...",
      selectAll: "Select all",
      selected: "selected",
      bulkDelete: "Delete selected",
      bulkChangeStatus: "Change status",
      bulkChangeStatusTitle: "Change status for selected items",
      bulkChangeStatusDesc: "Pick the new status for the selected vouchers",
      newStatus: "New status",
      bulkDeleteConfirm: "Delete {count} vouchers? This cannot be undone.",
      bulkDeleted: "{count} vouchers deleted",
      bulkUpdated: "{count} vouchers updated",
      sortAsc: "Sort ascending",
      sortDesc: "Sort descending",
    },
    shipments: {
      title: "Shipments",
      subtitle: "Track and manage order shipments",
      addNew: "Add Shipment",
      editShipment: "Edit Shipment",
      addDesc: "Create a new shipment for an order",
      editDesc: "Update shipment details",
      orderId: "Order ID",
      orderIdPlaceholder: "Enter order ID",
      orderNumber: "Order #",
      customer: "Customer",
      carrier: "Carrier",
      selectCarrier: "Select carrier",
      trackingNumber: "Tracking Number",
      trackingPlaceholder: "Enter tracking number",
      status: "Status",
      shippedDate: "Shipped Date",
      deliveredDate: "Delivered Date",
      notes: "Notes",
      statusPreparing: "Preparing",
      statusShipped: "Shipped",
      statusInTransit: "In Transit",
      statusDelivered: "Delivered",
      statusReturned: "Returned",
      created: "Shipment created successfully",
      updated: "Shipment updated successfully",
      deleted: "Shipment deleted",
      noShipments: "No shipments found",
      searchPlaceholder: "Search by tracking, carrier, order...",
    },
    fileManager: {
      title: "File Manager",
      subtitle: "Browse and edit files in the secure admin sandbox",
      files: "Files",
      noFile: "No file selected",
      selectHint: "Select a text file from the list to view and edit it",
      empty: "This folder is empty",
      refresh: "Refresh",
      newFolder: "New Folder",
      newFile: "New File",
      upload: "Upload",
      save: "Save",
      saved: "File saved",
      created: "File created",
      folderCreated: "Folder created",
      deleted: "Deleted",
      renamed: "Renamed",
      uploaded: "File uploaded",
      up: "Up",
      newFilePrompt: "New file name:",
      newFolderPrompt: "New folder name:",
      renamePrompt: "New name:",
      notEditable: "This file is not editable (binary or too large)",
      cancel: "Cancel",
      deleteTitle: "Confirm Deletion",
      deleteFileMsg: "File \"{name}\" will be permanently deleted. This action cannot be undone.",
      deleteFolderMsg: "Folder \"{name}\" and all its contents will be permanently deleted. This action cannot be undone.",
      confirmDelete: "Yes, Delete",
      saveTitle: "Confirm Save",
      saveMsg: "The content of \"{name}\" will be overwritten with your changes. Continue?",
      confirmSave: "Yes, Save",
    },
    extensions: {
      title: "Extensions",
      subtitle: "Manage integrations, payment gateways, shipping, analytics, and modules",
      allTypes: "All Types",
      payment: "Payment Methods",
      shipping: "Shipping Methods",
      email: "Email",
      whatsapp: "WhatsApp / SMS",
      analytics: "Analytics & Tracking",
      module: "Modules",
      integration: "Integrations",
      enabled: "Enabled",
      disabled: "Disabled",
      enable: "Enable",
      disable: "Disable",
      edit: "Edit",
      settings: "Settings",
      save: "Save Settings",
      cancel: "Cancel",
      status: "Status",
      name: "Name",
      type: "Type",
      actions: "Actions",
      noExtensions: "No extensions found in this category.",
      loadingExtensions: "Loading extensions...",
      extensionUpdated: "Extension updated successfully.",
      extensionSaved: "Extension settings saved.",
      saveFailed: "Failed to save extension settings.",
      testMode: "Test Mode",
      liveMode: "Live Mode",
      apiKey: "API Key",
      secretKey: "Secret Key",
      backToList: "Back to Extensions",
      generalSettings: "General Settings",
      notificationSettings: "Notification Settings",
      orderConfirmation: "Order Confirmation",
      orderStatusUpdate: "Order Status Update",
      contactFormReply: "Contact Form Reply",
      contactFormNotify: "Contact Form Notification",
      fromEmail: "From Email",
      fromName: "From Name",
      adminPhone: "Admin Phone Number",
      publishableKey: "Publishable Key",
      webhookSecret: "Webhook Secret",
      clientId: "Client ID",
      clientSecret: "Client Secret",
      accessToken: "Access Token",
      phoneNumberId: "WhatsApp Phone Number ID",
      wabaId: "WhatsApp Business Account ID (WABA)",
      verifyToken: "Webhook Verify Token",
      merchantCertificate: "Merchant Certificate",
      merchantDomain: "Merchant Domain",
      apiToken: "API Token",
      notificationToken: "Notification Token",
      merchantUrl: "Merchant URL",
      merchantCode: "Merchant Code",
      paymentType: "Payment Type",
      measurementId: "Measurement ID (G-XXXXXXXXXX)",
      propertyId: "Property ID (e.g. 123456789)",
      pixelId: "Pixel ID",
      containerId: "Container ID",
      trackPageViews: "Track Page Views",
      trackEvents: "Track Events",
      trackPurchases: "Track Purchases",
      trackAddToCart: "Track Add to Cart",
      bankName: "Bank Name",
      accountName: "Account Holder Name",
      accountNumber: "Account Number",
      iban: "IBAN",
      instructions: "Instructions",
      instructionsAr: "Instructions (Arabic)",
      shippingCost: "Shipping Cost",
      freeAbove: "Free Shipping Above",
      estimatedDays: "Estimated Delivery Days",
      address: "Address",
      workingHours: "Working Hours",
      fee: "Service Fee",
      provider: "Provider",
      widgetCode: "Widget Code",
      showPopup: "Show Popup",
      popupDelay: "Popup Delay (seconds)",
      discountCode: "Discount Code",
      daysAfterDelivery: "Days After Delivery",
      sendViaEmail: "Send via Email",
      sendViaWhatsApp: "Send via WhatsApp",
      entityId: "Entity ID",
      merchantId: "Merchant ID",
      currency: "Currency",
      apiId: "API ID",
      accessCode: "Access Code",
      shaRequestPhrase: "SHA Request Phrase",
      shaResponsePhrase: "SHA Response Phrase",
      shaType: "SHA Type (SHA-256 / SHA-512)",
      displayTitle: "Display name",
      routingWeightPct: "Routing weight (%) — share of transactions when 2+ card gateways are enabled",
      installed: "Installed Extensions",
      extensionTypes: "Extension Types",
      chooseType: "Choose extension type",
      addExtension: "Add Extension",
      deleteExtension: "Delete Extension",
      deleteConfirm: "Are you sure you want to delete this extension?",
      extensionDeleted: "Extension deleted.",
      extensionCode: "Extension Code",
      extensionName: "Extension Name (EN)",
      extensionNameAr: "Extension Name (AR)",
      extensionDesc: "Description (EN)",
      extensionDescAr: "Description (AR)",
    },
    marketingTracking: {
      title: "Marketing Tracking",
      campaigns: "Campaigns",
      campaignName: "Campaign Name",
      trackingCode: "Tracking Code",
      clicks: "Clicks",
      orders: "Orders",
      totalSales: "Total Sales",
      totalSalesHint: "Sum of confirmed order values (excluding cancelled and refunded) that used this campaign's tracking code as a coupon.",
      startDate: "Start Date",
      edit: "Edit",
      filter: "Filter",
      clearFilters: "Clear filters",
      sortBy: "Sort by",
      sortDir: "Direction",
      sortAsc: "Ascending",
      sortDesc: "Descending",
      sortName: "Name (A–Z)",
      sortCode: "Tracking Code",
      sortClicks: "Clicks",
      sortOrders: "Orders",
      sortTotalSales: "Total Sales",
      sortStartDate: "Start Date",
      trackingLink: "Tracking Link",
      copyLink: "Copy link",
      linkCopied: "Link copied",
      copyFailed: "Could not copy link",
      noCampaigns: "No marketing campaigns found.",
      addCampaign: "Add Campaign",
      editCampaign: "Edit Campaign",
      description: "Description",
      created: "Campaign created successfully",
      updated: "Campaign updated successfully",
      deleted: "Campaign deleted successfully",
      confirmDelete: "Are you sure you want to delete this campaign?",
    },
    googleShopping: {
      title: "Google Shopping",
      settings: "Settings",
      products: "Products",
      merchantId: "Merchant ID",
      targetCountry: "Target Country",
      currency: "Currency",
      contentLanguage: "Content Language",
      autoSync: "Auto Sync",
      syncInterval: "Sync Interval",
      syncIntervals: { "1": "Every hour", "2": "Every 2 hours", "4": "Every 4 hours", "6": "Every 6 hours", "12": "Every 12 hours", "24": "Every 24 hours", "48": "Every 48 hours" },
      includeOutOfStock: "Include Out of Stock",
      feedStatus: "Feed Status",
      active: "Active",
      inactive: "Inactive",
      lastSynced: "Last Synced",
      never: "Never",
      settingsSaved: "Settings saved successfully.",
      settingsFailed: "Failed to save settings.",
      feedUrl: "Feed URL",
      connectionMethod: "Connection Method",
      xmlFeed: "XML Feed (Scheduled Fetch)",
      xmlFeedDesc: "Generate a feed URL and add it to Google Merchant Center. Google fetches it on your chosen schedule.",
      xmlFeedStep1: "Copy the feed URL below",
      xmlFeedStep2: "Open Google Merchant Center → Products → Data Sources → Add Data Source",
      xmlFeedStep3: "Choose: Saudi Arabia, language: Arabic or English",
      xmlFeedStep4: "Select: Scheduled fetch — paste the URL",
      xmlFeedStep5: "Set the fetch schedule to match your sync interval above",
      localInventoryFeedTitle: "Local Inventory Feed (Local Inventory Ads)",
      localInventoryFeedDesc: "Required for Local Inventory Ads. Add this URL as a supplemental data source of type 'Local Products Inventory' in Google Merchant Center.",
      localInventoryFeedUrl: "Local Inventory Feed URL",
      storeCode: "Store Code",
      storeCodeDesc: "Enter the store code registered in your Business Profile. It links products to your physical or online store inventory.",
      storeCodePlaceholder: "e.g. ONLINE or your store code",
      localInventoryStep1: "Enter the store code above and save settings",
      localInventoryStep2: "Register the same code in Google My Business / Business Profile",
      localInventoryStep3: "Open Google Merchant Center → Products → Data Sources → Add Data Source",
      localInventoryStep4: "Select type 'Local Products Inventory' and paste the URL",
      contentApi: "Content API (Direct Push)",
      contentApiDesc: "Push products directly to Google Merchant Center automatically — no feed URL needed. Requires OAuth2 credentials from Google Cloud Console.",
      contentApiClientId: "OAuth2 Client ID",
      contentApiClientSecret: "OAuth2 Client Secret",
      contentApiHint: "Create OAuth2 credentials in Google Cloud Console → APIs & Services → Credentials, then enable the Content API for Shopping.",
      connectWithGoogle: "Connect with Google",
      oauthConnected: "Connected to Google ✓",
      oauthConnectedSince: "Connected since",
      oauthDisconnect: "Disconnect",
      oauthRedirectUri: "Redirect URI (add this in Google Cloud Console)",
      oauthConnectStep1: "Save the Client ID and Client Secret above",
      oauthConnectStep2: "In Google Cloud Console → Credentials → OAuth Client, add the green redirect URI below under Authorized redirect URIs",
      oauthConnectStep3: "Click «Connect with Google» and approve permissions",
      oauthConnectSuccess: "Google account connected successfully",
      oauthConnectError: "Failed to connect Google account",
      syncPushed: "Pushed {{count}} products to Google Merchant Center",
      syncErrors: "Failed to push {{count}} products",
      addProduct: "Add Product",
      productName: "Product",
      googleCategory: "Google Category",
      condition: "Condition",
      availability: "Availability",
      excluded: "Excluded",
      included: "Included",
      status: "Status",
      actions: "Actions",
      noProducts: "No products added to Google Shopping feed.",
      productAdded: "Product added to feed.",
      productRemoved: "Product removed from feed.",
      conditions: {
        new: "New",
        refurbished: "Refurbished",
        used: "Used",
      },
      availabilities: {
        in_stock: "In Stock",
        out_of_stock: "Out of Stock",
        preorder: "Preorder",
      },
      searchPlaceholder: "Search products...",
      selectedCount: "{n} selected",
      bulkEditSelected: "Edit selected",
      includeSelected: "Include selected",
      excludeSelected: "Exclude selected",
      removeSelected: "Remove selected",
      bulkActionApplied: "Action applied to {n} product(s)",
      bulkEditApplied: "Updated {n} product(s)",
      bulkEditFailed: "Bulk edit failed",
      pickFieldFirst: "Pick at least one field to update",
      filterAll: "All",
      filterNoCategory: "— No category —",
      resultsCount: "{n} result(s)",
      clearFilters: "Clear filters",
      bulkEditTitle: "Bulk edit {n} product(s)",
      bulkEditHint: "Leave any field empty to keep it unchanged. Changes apply only to the selected rows.",
      leaveUnchanged: "Leave unchanged",
      applyBtn: "Apply",
      cancelBtn: "Cancel",
      hiddenSelectionWarning: "{n} selected item(s) are hidden by current filters and will still be affected.",
    },
    facebookCatalog: {
      title: "Facebook Catalog",
      settings: "Settings",
      products: "Products",
      businessId: "Business ID",
      catalogId: "Catalog ID",
      pixelId: "Pixel ID",
      targetCountry: "Target Country",
      currency: "Currency",
      contentLanguage: "Content Language",
      autoSync: "Auto Sync",
      syncInterval: "Sync Interval (hours)",
      includeOutOfStock: "Include Out of Stock",
      feedStatus: "Feed Status",
      active: "Active",
      inactive: "Inactive",
      lastSynced: "Last Synced",
      never: "Never",
      settingsSaved: "Settings saved successfully.",
      settingsFailed: "Failed to save settings.",
      feedUrl: "Feed URL",
      addProduct: "Add Product",
      productName: "Product",
      fbCategory: "Facebook Category",
      condition: "Condition",
      availability: "Availability",
      excluded: "Excluded",
      included: "Included",
      status: "Status",
      actions: "Actions",
      noProducts: "No products in Facebook catalog.",
      productAdded: "Product added to catalog.",
      productRemoved: "Product removed from catalog.",
      conditions: { new: "New", refurbished: "Refurbished", used: "Used" },
      availabilities: { in_stock: "In Stock", out_of_stock: "Out of Stock", preorder: "Preorder" },
      searchPlaceholder: "Search products...",
      selectedCount: "{n} selected",
      bulkEditSelected: "Edit selected",
      includeSelected: "Include selected",
      excludeSelected: "Exclude selected",
      removeSelected: "Remove selected",
      bulkActionApplied: "Action applied to {n} product(s)",
      bulkEditApplied: "Updated {n} product(s)",
      bulkEditFailed: "Bulk edit failed",
      pickFieldFirst: "Pick at least one field to update",
      filterAll: "All",
      filterNoCategory: "— No category —",
      resultsCount: "{n} result(s)",
      clearFilters: "Clear filters",
      bulkEditTitle: "Bulk edit {n} product(s)",
      bulkEditHint: "Leave any field empty to keep it unchanged. Changes apply only to the selected rows.",
      leaveUnchanged: "Leave unchanged",
      applyBtn: "Apply",
      cancelBtn: "Cancel",
      hiddenSelectionWarning: "{n} selected item(s) are hidden by current filters and will still be affected.",
      syncNow: "Sync now",
      addAll: "Add all products",
      addToFeed: "Add products to Facebook Catalog",
      defaultCategory: "Facebook category (default)",
      none: "None",
      noResults: "No results",
      productsSelected: "{n} product(s) selected",
      cancel: "Cancel",
      addBtn: "Add",
      addedSkipped: "Added {added} product(s) (skipped {skipped} duplicates)",
      addFailed: "Failed to add",
      addAllConfirm: "Add all active products to the Facebook Catalog?",
      addedOfTotal: "Added {added} of {total} product(s)",
      syncedToast: "Sync time updated. Live Facebook Graph API push will be enabled in a later step.",
      addDialogTitle: "Add products to Facebook Catalog",
      product: "Product",
      sku: "SKU",
      price: "Price",
      pageInfo: "Showing {from}–{to} of {total} product(s)",
      prev: "Previous",
      next: "Next",
      pageOf: "Page {page} of {total}",
      businessIdHint: "From Meta Business Suite → Settings → Business Info",
      catalogIdHint: "From Commerce Manager → Catalog → Settings",
      feedUrlHint: "Copy this URL into Commerce Manager → Data Sources → Add Data Source → Scheduled feed",
      apiNote: "Note: Direct Facebook Graph API integration will be enabled in a later step. For now the system generates an XML feed that can be added manually in Commerce Manager.",
    },
    snapchatCatalog: {
      title: "Snapchat Catalog",
      subtitle: "Connect your product catalog to Snapchat and run Shopping Ads",
      settings: "Settings",
      products: "Products",
      snapCatalogId: "Catalog ID",
      snapCatalogIdHint: "From Snap Business Manager → Catalogs → Catalog Settings",
      businessId: "Business ID",
      pixelId: "Pixel ID",
      optional: "optional",
      targetCountry: "Target Country",
      currency: "Currency",
      contentLanguage: "Content Language",
      autoSync: "Auto Sync",
      syncInterval: "Sync Interval (hours)",
      includeOutOfStock: "Include Out of Stock",
      feedStatus: "Feed Status",
      active: "Active",
      inactive: "Inactive",
      lastSynced: "Last Synced",
      never: "Never",
      settingsSaved: "Settings saved successfully.",
      settingsFailed: "Failed to save settings.",
      feedUrl: "Feed URL",
      feedUrlHint: "Copy this URL into Snap Business Manager → Catalogs → Import Method → Scheduled Feed",
      howToConnect: "How to connect with Snap Business Manager:",
      step1: "Open Snap Business Manager → Catalogs → Create a new catalog",
      step2: "Select Import Method: Scheduled Feed",
      step3: "Paste the feed URL above and set your refresh schedule",
      step4: "Save the catalog and start running Collection Ads or Dynamic Ads",
      copied: "URL copied",
      syncNow: "Sync now",
      syncDone: "Sync time updated.",
      addProduct: "Add Product",
      addAll: "Add all products",
      addToFeed: "Add products to Snapchat Catalog",
      defaultCategory: "Snapchat category (default)",
      confirmAddAll: "Add all active products to the Snapchat Catalog?",
      addedTotal: "Added {added} of {total} product(s)",
      addedSkipped: "Added {added} product(s) (skipped {skipped} duplicates)",
      addFailed: "Failed to add",
      save: "Save settings",
      snapCategory: "Snapchat Category",
      condition: "Condition",
      availability: "Availability",
      excluded: "Excluded",
      included: "Included",
      status: "Status",
      actions: "Actions",
      noProducts: "No products in Snapchat catalog.",
      productAdded: "Product added to catalog.",
      productRemoved: "Product removed from catalog.",
      conditions: { new: "New", refurbished: "Refurbished", used: "Used" },
      availabilities: { in_stock: "In Stock", out_of_stock: "Out of Stock", preorder: "Preorder" },
      searchPlaceholder: "Search products...",
      selectedCount: "{n} selected",
      bulkEditSelected: "Edit selected",
      includeSelected: "Include selected",
      excludeSelected: "Exclude selected",
      removeSelected: "Remove selected",
      bulkActionApplied: "Action applied to {n} product(s)",
      bulkEditApplied: "Updated {n} product(s)",
      bulkEditFailed: "Bulk edit failed",
      pickFieldFirst: "Pick at least one field to update",
      filterAll: "All",
      filterNoCategory: "— No category —",
      resultsCount: "{n} result(s)",
      clearFilters: "Clear filters",
      bulkEditTitle: "Bulk edit {n} product(s)",
      bulkEditHint: "Leave any field empty to keep it unchanged. Changes apply only to the selected rows.",
      leaveUnchanged: "Leave unchanged",
      applyBtn: "Apply",
      cancelBtn: "Cancel",
      none: "None",
      noResults: "No results",
      productsSelected: "{n} product(s) selected",
      cancel: "Cancel",
      addBtn: "Add",
      totalInFeed: "Total products in catalog",
      activeProducts: "Active products",
      excludedProducts: "Excluded products",
      productName: "Product",
      price: "Price",
    },
    tiktokCatalog: {
      title: "TikTok Catalog",
      subtitle: "Connect your product catalog to TikTok and run Shopping Ads",
      settings: "Settings",
      products: "Products",
      advertiserId: "Advertiser ID",
      advertiserIdHint: "From TikTok Ads Manager → Account Info",
      catalogId: "Catalog ID",
      catalogIdHint: "From TikTok Ads Manager → Assets → Catalog → Catalog Settings",
      targetCountry: "Target Country",
      currency: "Currency",
      contentLanguage: "Content Language",
      autoSync: "Auto Sync",
      syncInterval: "Sync Interval (hours)",
      includeOutOfStock: "Include Out of Stock",
      feedStatus: "Feed Status",
      active: "Active",
      inactive: "Inactive",
      lastSynced: "Last Synced",
      never: "Never",
      settingsSaved: "Settings saved successfully.",
      settingsFailed: "Failed to save settings.",
      feedUrl: "Feed URL",
      feedUrlHint: "Copy this URL into TikTok Ads Manager → Assets → Catalog → Data Source → Scheduled Feed",
      howToConnect: "How to connect with TikTok Ads Manager:",
      step1: "Open TikTok Ads Manager → Assets → Catalog → Create Catalog",
      step2: "Select Data Source → Scheduled Feed",
      step3: "Paste the feed URL above and set your refresh schedule",
      step4: "Save the catalog and start running Shopping or Video Shopping Ads",
      copied: "URL copied",
      syncNow: "Sync now",
      syncDone: "Sync time updated.",
      addProduct: "Add Product",
      addAll: "Add all products",
      addToFeed: "Add products to TikTok Catalog",
      defaultCategory: "TikTok category (default)",
      confirmAddAll: "Add all active products to the TikTok Catalog?",
      addedTotal: "Added {added} of {total} product(s)",
      addedSkipped: "Added {added} product(s) (skipped {skipped} duplicates)",
      addFailed: "Failed to add",
      save: "Save settings",
      tiktokCategory: "TikTok Category",
      condition: "Condition",
      availability: "Availability",
      excluded: "Excluded",
      included: "Included",
      status: "Status",
      actions: "Actions",
      noProducts: "No products in TikTok catalog.",
      productAdded: "Product added to catalog.",
      productRemoved: "Product removed from catalog.",
      conditions: { new: "New", refurbished: "Refurbished", used: "Used" },
      availabilities: { in_stock: "In Stock", out_of_stock: "Out of Stock", preorder: "Preorder" },
      searchPlaceholder: "Search products...",
      selectedCount: "{n} selected",
      bulkEditSelected: "Edit selected",
      includeSelected: "Include selected",
      excludeSelected: "Exclude selected",
      removeSelected: "Remove selected",
      bulkActionApplied: "Action applied to {n} product(s)",
      bulkEditApplied: "Updated {n} product(s)",
      bulkEditFailed: "Bulk edit failed",
      pickFieldFirst: "Pick at least one field to update",
      filterAll: "All",
      filterNoCategory: "— No category —",
      resultsCount: "{n} result(s)",
      clearFilters: "Clear filters",
      bulkEditTitle: "Bulk edit {n} product(s)",
      bulkEditHint: "Leave any field empty to keep it unchanged. Changes apply only to the selected rows.",
      leaveUnchanged: "Leave unchanged",
      applyBtn: "Apply",
      cancelBtn: "Cancel",
      none: "None",
      noResults: "No results",
      productsSelected: "{n} product(s) selected",
      cancel: "Cancel",
      addBtn: "Add",
      totalInFeed: "Total products in catalog",
      activeProducts: "Active products",
      excludedProducts: "Excluded products",
      productName: "Product",
      price: "Price",
    },
    affiliates: {
      title: "Affiliates",
      subtitle: "Manage affiliate partners and commissions",
      addAffiliate: "Add Affiliate",
      editAffiliate: "Edit Affiliate",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      company: "Company",
      website: "Website",
      trackingCode: "Tracking Code",
      commissionRate: "Commission Rate (%)",
      paymentMethod: "Payment Method",
      bankDetails: "Bank Details",
      status: "Status",
      balance: "Balance",
      totalEarned: "Total Earned",
      totalClicks: "Total Clicks",
      totalOrders: "Total Orders",
      name: "Name",
      actions: "Actions",
      noAffiliates: "No affiliates found.",
      affiliateCreated: "Affiliate created successfully.",
      affiliateUpdated: "Affiliate updated successfully.",
      affiliateDeleted: "Affiliate deleted.",
      saveFailed: "Failed to save affiliate.",
      pending: "Pending",
      active: "Active",
      inactive: "Inactive",
      paymentMethods: {
        bank_transfer: "Bank Transfer",
        paypal: "PayPal",
        wallet: "Wallet",
      },
      transactions: "Transactions",
      addTransaction: "Add Transaction",
      txType: "Type",
      txAmount: "Amount",
      txDescription: "Description",
      txStatus: "Status",
      txDate: "Date",
      noTransactions: "No transactions yet.",
      txCreated: "Transaction created.",
      txTypes: {
        commission: "Commission",
        payment: "Payment",
        adjustment: "Adjustment",
      },
      txStatuses: {
        pending: "Pending",
        approved: "Approved",
        paid: "Paid",
        cancelled: "Cancelled",
      },
    },
    emailCampaigns: {
      title: "Email Campaigns",
      subtitle: "Send email campaigns to your customers",
      addCampaign: "New Campaign",
      editCampaign: "Edit Campaign",
      name: "Campaign Name (EN)",
      nameAr: "Campaign Name (AR)",
      subject: "Subject (EN)",
      subjectAr: "Subject (AR)",
      content: "Content EN (HTML)",
      contentAr: "Content AR (HTML)",
      recipientType: "Recipients",
      recipientAll: "All Customers",
      recipientGroup: "Customer Group",
      recipientNewsletter: "Newsletter Subscribers",
      recipientCustom: "Custom Email List",
      recipientSpecific: "Specific Customers",
      selectGroup: "Select Group",
      customEmailsLabel: "Email addresses",
      customEmailsHint: "Separate addresses with commas or new lines. Invalid addresses are ignored. Max 5,000.",
      validEmailsCount: "{count} valid email address(es)",
      searchCustomers: "Search customers by name, email, or phone",
      addToList: "Add",
      removeEmailAria: "Remove email",
      noCustomersFound: "No matching customers",
      compose: "Compose",
      preview: "Preview",
      previewArabic: "Arabic Preview",
      previewEnglish: "English Preview",
      previewEmpty: "Nothing to preview yet. Write your message in the Compose tab.",
      status: "Status",
      sentCount: "Sent",
      openCount: "Opens",
      scheduledAt: "Schedule",
      sentAt: "Sent At",
      actions: "Actions",
      noCampaigns: "No email campaigns found.",
      campaignCreated: "Campaign created successfully.",
      campaignUpdated: "Campaign updated successfully.",
      campaignDeleted: "Campaign deleted.",
      saveFailed: "Failed to save campaign.",
      sendNow: "Send Now",
      sendConfirm: "Are you sure you want to send this campaign now?",
      sending: "Sending...",
      sendSuccess: "Campaign sent successfully!",
      sendFailed: "Failed to send campaign.",
      statuses: {
        draft: "Draft",
        scheduled: "Scheduled",
        sending: "Sending",
        sent: "Sent",
        cancelled: "Cancelled",
      },
    },
    smsCampaigns: {
      title: "SMS Messages",
      subtitle: "Send SMS and WhatsApp messages to customers",
      addCampaign: "New Message",
      editCampaign: "Edit Message",
      name: "Campaign Name",
      nameAr: "Campaign Name (AR)",
      message: "Message",
      messageAr: "Message (AR)",
      recipientType: "Recipients",
      recipientAll: "All Customers",
      recipientGroup: "Customer Group",
      selectGroup: "Select Group",
      channel: "Channel",
      status: "Status",
      sentCount: "Sent",
      scheduledAt: "Schedule",
      sentAt: "Sent At",
      actions: "Actions",
      noCampaigns: "No SMS campaigns found.",
      campaignCreated: "Campaign created successfully.",
      campaignUpdated: "Campaign updated successfully.",
      campaignDeleted: "Campaign deleted.",
      saveFailed: "Failed to save campaign.",
      sendNow: "Send Now",
      sendConfirm: "Are you sure you want to send this campaign now?",
      sending: "Sending...",
      sendSuccess: "Messages sent successfully!",
      sendFailed: "Failed to send messages.",
      channels: {
        sms: "SMS",
        whatsapp: "WhatsApp",
      },
      statuses: {
        draft: "Draft",
        scheduled: "Scheduled",
        sending: "Sending",
        sent: "Sent",
        cancelled: "Cancelled",
      },
      languageNote: "Each customer receives the message in their preferred language. If you leave one field empty, the other variant is used as fallback.",
      scheduleSection: "Scheduling",
      scheduleSendLater: "Send Later",
      scheduleHelp: "If a time is set, the message will be sent automatically at that time — no manual action needed.",
      filterSection: "Recipient Filter",
      filterLastOrderDays: "No order for at least (days)",
      filterLastOrderHint: "Exclude customers who ordered recently. Example: 365 to target customers who haven't ordered in a year.",
      filterTotalSpentMin: "Total spent (min)",
      filterTotalSpentMax: "Total spent (max)",
      filterClear: "Clear filters",
      schedulingTitle: "Scheduled for",
      previewSection: "Audience Preview",
      previewButton: "Preview recipients",
      previewLoading: "Loading recipients...",
      previewEmpty: "No customers match the current filters.",
      previewMatched: "Matched",
      previewOptedOut: "Excluded (opted-out)",
      previewWillReceive: "Will receive",
      previewColCustomer: "Customer",
      previewColPhone: "Phone",
      previewColLanguage: "Lang",
      previewColTotalSpent: "Total Spent",
      previewColLastOrder: "Last Order",
      previewPageInfo: "Page {page} of {totalPages}",
      previewPrev: "Previous",
      previewNext: "Next",
      previewHint: "These are the only customers who will receive the message. Customers in the opt-out list are excluded automatically.",
    },
    blog: {
      title: "Blog",
      settings: "Blog Settings",
      categories: "Blog Categories",
      posts: "Blog Posts",
      comments: "Blog Comments",
      settingsSubtitle: "Configure blog display and SEO settings",
      categoriesSubtitle: "Manage blog post categories",
      postsSubtitle: "Create and manage blog articles",
      commentsSubtitle: "Moderate reader comments",
      postsPerPage: "Posts Per Page",
      allowComments: "Allow Comments",
      moderateComments: "Moderate Comments",
      showAuthor: "Show Author",
      showDate: "Show Date",
      showReadTime: "Show Read Time",
      showShareButtons: "Show Share Buttons",
      showRelatedPosts: "Show Related Posts",
      relatedPostsCount: "Related Posts Count",
      seoTitle: "Blog SEO Title",
      seoTitleAr: "Blog SEO Title (AR)",
      seoDescription: "Blog SEO Description",
      seoDescriptionAr: "Blog SEO Description (AR)",
      settingsSaved: "Blog settings saved.",
      addCategory: "Add Category",
      editCategory: "Edit Category",
      categoryName: "Category Name",
      categoryNameAr: "Category Name (AR)",
      categorySlug: "Slug",
      categoryDescription: "Description",
      categoryDescriptionAr: "Description (AR)",
      categoryImage: "Image URL",
      categorySortOrder: "Sort Order",
      categoryStatus: "Status",
      noCategories: "No blog categories yet.",
      categoryCreated: "Category created.",
      categoryUpdated: "Category updated.",
      categoryDeleted: "Category deleted.",
      addPost: "New Post",
      editPost: "Edit Post",
      postTitle: "Title",
      postTitleAr: "Title (AR)",
      postSlug: "Slug",
      autoGenerated: "Auto-generated if empty",
      postContent: "Content (HTML)",
      postContentAr: "Content AR (HTML)",
      postExcerpt: "Excerpt",
      postExcerptAr: "Excerpt (AR)",
      postFeaturedImage: "Featured Image URL",
      postCategory: "Category",
      postAuthor: "Author Name",
      postAuthorAr: "Author Name (AR)",
      postStatus: "Status",
      postPublishedAt: "Publish Date",
      postTags: "Tags (comma-separated)",
      postTagsAr: "Tags AR (comma-separated)",
      postMetaTitle: "Meta Title",
      postMetaTitleAr: "Meta Title (AR)",
      postMetaDescription: "Meta Description",
      postMetaDescriptionAr: "Meta Description (AR)",
      seoTab: "SEO",
      seoTips: "SEO tips: Keep meta title under 60 characters. Keep meta description under 160 characters. Use relevant keywords in both languages.",
      postAllowComments: "Allow Comments",
      postFeatured: "Featured Post",
      postReadTime: "Read Time",
      postViewCount: "Views",
      noPosts: "No blog posts yet.",
      postCreated: "Post created.",
      postUpdated: "Post updated.",
      postDeleted: "Post deleted.",
      saveFailed: "Failed to save.",
      selectCategory: "Select Category",
      allCategories: "All Categories",
      allStatuses: "All Statuses",
      commentAuthor: "Author",
      commentEmail: "Email",
      commentContent: "Comment",
      commentPost: "Post",
      commentStatus: "Status",
      commentDate: "Date",
      noComments: "No comments yet.",
      commentUpdated: "Comment status updated.",
      commentDeleted: "Comment deleted.",
      approve: "Approve",
      reject: "Reject",
      markSpam: "Spam",
      statuses: {
        draft: "Draft",
        published: "Published",
        scheduled: "Scheduled",
        active: "Active",
        inactive: "Inactive",
        pending: "Pending",
        approved: "Approved",
        rejected: "Rejected",
        spam: "Spam",
      },
      minutes: "min read",
      views: "views",
      comments_count: "comments",
      readMore: "Read More",
      searchPosts: "Search articles...",
      noResults: "No articles found.",
      shareArticle: "Share this article",
      relatedPosts: "Related Articles",
      leaveComment: "Leave a Comment",
      yourName: "Your Name",
      yourEmail: "Your Email",
      yourComment: "Your Comment",
      submitComment: "Submit Comment",
      commentSubmitted: "Comment submitted successfully! It will appear after moderation.",
      commentFailed: "Failed to submit comment.",
      backToBlog: "Back to Blog",
      featuredPosts: "Featured",
      latestPosts: "Latest Articles",
      allPosts: "All Articles",
      blogHome: "Blog",
    },
    seo: {
      title: "SEO Management",
      subtitle: "Manage search engine optimization settings",
      seoUrls: "SEO URLs",
      redirects: "Redirects",
      sitemap: "Sitemap",
      robotsTxt: "Robots.txt",
      addUrl: "Add SEO URL",
      editUrl: "Edit SEO URL",
      entityType: "Entity Type",
      entityId: "Entity ID",
      keyword: "URL Keyword",
      metaTitle: "Meta Title",
      metaTitleAr: "Meta Title (AR)",
      metaDescription: "Meta Description",
      metaDescriptionAr: "Meta Description (AR)",
      metaKeywords: "Meta Keywords",
      metaKeywordsAr: "Meta Keywords (AR)",
      canonicalUrl: "Canonical URL",
      ogTitle: "OG Title",
      ogDescription: "OG Description",
      ogImage: "OG Image URL",
      addRedirect: "Add Redirect",
      editRedirect: "Edit Redirect",
      sourceUrl: "Source URL",
      targetUrl: "Target URL",
      statusCode: "Status Code",
      hits: "Hits",
      generateSitemap: "Generate Sitemap",
      sitemapGenerated: "Sitemap generated successfully",
      sitemapFailed: "Failed to generate sitemap",
      viewSitemap: "View Sitemap",
      robotsContent: "Robots.txt Content",
      saveRobots: "Save Robots.txt",
      robotsSaved: "Robots.txt saved successfully",
      robotsFailed: "Failed to save robots.txt",
      product: "Product",
      category: "Category",
      page: "Page",
      brand: "Brand",
      blogPost: "Blog Post",
      permanent301: "301 (Permanent)",
      temporary302: "302 (Temporary)",
      noUrls: "No SEO URLs found",
      noRedirects: "No redirects found",
      urlSaved: "SEO URL saved successfully",
      urlDeleted: "SEO URL deleted",
      redirectSaved: "Redirect saved successfully",
      redirectDeleted: "Redirect deleted",
      saveFailed: "Failed to save",
      deleteFailed: "Failed to delete",
      sitemapTip: "Generates XML sitemap including all products, categories, blog posts and pages for search engine indexing.",
      robotsTip: "Controls which pages search engines can crawl. Edit with care.",
      dashboard: "Dashboard",
      dashboardDesc: "Overview of your store's SEO health",
      totalProducts: "Total Products",
      totalCategories: "Total Categories",
      totalPages: "Total Pages",
      totalBrands: "Total Brands",
      totalBlogPosts: "Total Blog Posts",
      totalSeoUrls: "SEO URLs Configured",
      totalRedirects: "Active Redirects",
      missingMeta: "Missing Meta Data",
      productsNoMeta: "Products without Meta Title",
      categoriesNoMeta: "Categories without Meta Title",
      pagesNoMeta: "Pages without Meta Title",
      postsNoMeta: "Blog Posts without Meta Title",
      productsNoDesc: "Products without Meta Description",
      seoHealth: "SEO Health Score",
      seoHealthGood: "Good",
      seoHealthWarning: "Needs Improvement",
      seoHealthBad: "Critical",
      massUpdate: "Mass Update",
      massUpdateDesc: "Generate SEO data in bulk from templates",
      selectEntityType: "Select Entity Type",
      metaTitleTemplate: "Meta Title Template",
      metaTitleTemplateAr: "Meta Title Template (AR)",
      metaDescTemplate: "Meta Description Template",
      metaDescTemplateAr: "Meta Description Template (AR)",
      metaKeywordsTemplate: "Meta Keywords Template",
      metaKeywordsTemplateAr: "Meta Keywords Template (AR)",
      templateHelp: "Available variables: {name}, {nameAr}, {type}",
      generatePreview: "Preview",
      applyAll: "Apply to All",
      applySelected: "Apply to Selected",
      selectAll: "Select All",
      deselectAll: "Deselect All",
      generated: "Generated",
      current: "Current",
      massUpdateSuccess: "Mass update completed successfully",
      massUpdateCount: "entities updated",
      saveTemplate: "Save Template",
      templateSaved: "Template saved successfully",
      richSnippets: "Rich Snippets",
      richSnippetsDesc: "Manage structured data (Schema.org) for search results",
      enableRichSnippets: "Enable Rich Snippets",
      productSchema: "Product Schema (price, availability, rating)",
      organizationSchema: "Organization Schema",
      breadcrumbSchema: "Breadcrumb Schema",
      blogSchema: "Blog/Article Schema",
      faqSchema: "FAQ Schema",
      orgName: "Organization Name",
      orgLogo: "Organization Logo URL",
      orgPhone: "Organization Phone",
      orgEmail: "Organization Email",
      socialLinks: "Social Media Links (one per line)",
      richSnippetsSaved: "Rich Snippets settings saved",
      analytics: "Analytics",
      analyticsDesc: "Connect tracking and analytics services",
      googleAnalyticsId: "Google Analytics ID (GA4)",
      googleAnalyticsPlaceholder: "G-XXXXXXXXXX",
      googleTagManagerId: "Google Tag Manager ID",
      googleTagManagerPlaceholder: "GTM-XXXXXXX",
      searchConsoleVerification: "Google Search Console Verification",
      searchConsolePlaceholder: "Verification meta tag content",
      facebookPixelId: "Facebook Pixel ID",
      snapchatPixelId: "Snapchat Pixel ID",
      tiktokPixelId: "TikTok Pixel ID",
      analyticsSaved: "Analytics settings saved",
      analyticsTip: "Enter your tracking IDs to integrate analytics services with your store.",
    },
    appearance: {
      title: "Appearance",
      subtitle: "Customize your store appearance and layout",
      colorsTab: "Colors & Fonts",
      headerTab: "Header",
      footerTab: "Footer",
      productTab: "Product Display",
      codeTab: "Custom Code",
      primaryColor: "Primary Color",
      secondaryColor: "Secondary Color",
      accentColor: "Accent Color",
      backgroundColor: "Background Color",
      textColor: "Text Color",
      fontFamily: "Font Family (EN)",
      fontFamilyAr: "Font Family (AR)",
      fontSize: "Base Font Size",
      borderRadius: "Border Radius",
      headerBg: "Header Background",
      headerTextColor: "Header Text Color",
      headerLayout: "Header Layout",
      layoutDefault: "Default",
      layoutCentered: "Centered Logo",
      layoutMinimal: "Minimal",
      stickyHeader: "Sticky Header",
      topBarEnabled: "Show Top Bar",
      topBarText: "Top Bar Text",
      topBarTextAr: "Top Bar Text (AR)",
      topBarBg: "Top Bar Background",
      topBarTextColor: "Top Bar Text Color",
      footerBg: "Footer Background",
      footerTextColor: "Footer Text Color",
      footerLayout: "Footer Layout",
      logoUrl: "Logo URL",
      faviconUrl: "Favicon URL",
      productCardStyle: "Product Card Style",
      styleDefault: "Default",
      styleMinimal: "Minimal",
      styleBordered: "Bordered",
      productsPerRow: "Products Per Row",
      showQuickView: "Show Quick View",
      showWishlistBtn: "Show Wishlist Button",
      showCompareBtn: "Show Compare Button",
      backToTop: "Back to Top Button",
      lazyLoadImages: "Lazy Load Images",
      customCss: "Custom CSS",
      customJs: "Custom JavaScript",
      customHeaderCode: "Custom Header Code (HTML)",
      customFooterCode: "Custom Footer Code (HTML)",
      settingsSaved: "Theme settings saved successfully",
      settingsFailed: "Failed to save theme settings",
      resetDefaults: "Reset to Defaults",
      preview: "Preview",
      cssTip: "Add custom CSS to override default styles. Changes apply globally.",
      jsTip: "Add custom JavaScript. Executes on every page load.",
      headerCodeTip: "Injected inside <head> tag. Use for analytics, fonts, etc.",
      footerCodeTip: "Injected before </body>. Use for tracking scripts.",
      importExportTab: "Import / Export",
      performanceTab: "Performance",
      exportTheme: "Export Theme",
      exportThemeDesc: "Download all theme settings as a JSON file for backup or transfer to another store.",
      exportBtn: "Export Settings",
      importTheme: "Import Theme",
      importThemeDesc: "Upload a previously exported JSON settings file to restore or apply a theme configuration.",
      importBtn: "Import Settings",
      importSuccess: "Theme imported successfully",
      importFailed: "Failed to import theme. Invalid file.",
      selectFile: "Select JSON File",
      dragDrop: "or drag and drop",
      fileSelected: "File selected",
      importWarning: "This will overwrite all current theme settings. Make sure to export your current settings first.",
      perfLazyLoading: "Lazy Load Images",
      perfLazyLoadingDesc: "Defer loading of offscreen images until users scroll near them.",
      perfMinifyCss: "Minify CSS",
      perfMinifyCssDesc: "Remove whitespace and comments from CSS for smaller file size.",
      perfMinifyJs: "Minify JavaScript",
      perfMinifyJsDesc: "Compress JavaScript output for faster page loads.",
      perfCacheBusting: "Cache Busting",
      perfCacheBustingDesc: "Add version hash to asset URLs so browsers always load the latest files.",
      perfPreconnect: "Preconnect to CDN",
      perfPreconnectDesc: "Establish early connections to CDN origins for faster resource loading.",
      perfDeferJs: "Defer JavaScript Loading",
      perfDeferJsDesc: "Delay non-critical JavaScript execution until the page is interactive.",
      perfImageOptimize: "Image Optimization",
      perfImageOptimizeDesc: "Automatically serve optimized image formats (WebP) when supported.",
      perfCriticalCss: "Critical CSS Inlining",
      perfCriticalCssDesc: "Inline above-the-fold CSS for faster initial paint.",
      perfCacheTime: "Browser Cache Duration",
      perfCacheTimeDesc: "How long browsers should cache static assets.",
      perfCacheOptions: {
        "1h": "1 Hour",
        "1d": "1 Day",
        "1w": "1 Week",
        "1m": "1 Month",
        "1y": "1 Year",
      },
    },
    activityLog: {
      title: "Activity Log",
      subtitle: "Track all operations performed by store administrators",
      admin: "Administrator",
      action: "Action",
      actionType: "Action Type",
      entityType: "Section",
      entityName: "Item",
      ipAddress: "IP Address",
      date: "Date & Time",
      details: "Details",
      allAdmins: "All Administrators",
      allActions: "All Actions",
      login: "Login",
      logout: "Logout",
      create: "Create",
      edit: "Edit",
      delete: "Delete",
      view: "View",
      dateFrom: "From Date",
      dateTo: "To Date",
      search: "Search...",
      clearFilters: "Clear Filters",
      clearLogs: "Clear Logs",
      clearConfirm: "Are you sure you want to clear all activity logs? This action cannot be undone.",
      cleared: "Activity logs cleared successfully",
      noLogs: "No activity logs found",
      filterByDate: "Filter by date range",
      products: "Products",
      orders: "Orders",
      customers: "Customers",
      categories: "Categories",
      settings: "Settings",
      coupons: "Coupons",
      banners: "Banners",
      pages: "Pages",
      returns: "Returns",
      brands: "Brands",
      extensions: "Extensions",
      blog: "Blog",
      seo: "SEO",
      theme: "Theme",
    },
    abandonedCarts: {
      title: "Abandoned Carts",
      subtitle: "Track and recover abandoned shopping carts",
      totalAbandoned: "Total Abandoned",
      totalRecovered: "Recovered",
      recoveryRate: "Recovery Rate",
      potentialRevenue: "Potential Revenue",
      recoveredRevenue: "Recovered Revenue",
      cartId: "Cart ID",
      customer: "Customer",
      email: "Email",
      phone: "Phone",
      items: "Items",
      total: "Total",
      date: "Date",
      status: "Status",
      actions: "Actions",
      abandoned: "Abandoned",
      recovered: "Recovered",
      reminderSent: "Reminder Sent",
      sendReminder: "Send Reminder",
      sendEmail: "Send Email",
      sendWhatsApp: "Send WhatsApp",
      markRecovered: "Mark as Recovered",
      viewItems: "View Items",
      cartItems: "Cart Items",
      productName: "Product",
      quantity: "Quantity",
      price: "Price",
      reminderCount: "Reminders Sent",
      lastReminder: "Last Reminder",
      noCarts: "No abandoned carts found",
      reminderSentSuccess: "Reminder sent successfully",
      reminderFailed: "Failed to send reminder",
      markedRecovered: "Cart marked as recovered",
      filterAll: "All Carts",
      filterAbandoned: "Abandoned Only",
      filterRecovered: "Recovered Only",
      filterReminded: "Reminded",
      autoReminder: "Auto Reminders",
      autoReminderTip: "Automatically send reminders to customers who abandoned their carts after a set time period.",
      timeSinceAbandoned: "Time Since Abandoned",
      hoursAgo: "hours ago",
      daysAgo: "days ago",
      minutesAgo: "minutes ago",
      guestCustomer: "Guest",
      settingsTab: "Settings",
      templatesTab: "Message Templates",
      addEmailTemplate: "Add Email Template",
      addWhatsappTemplate: "Add WhatsApp Template",
      editEmailTemplate: "Edit Email Template",
      editWhatsappTemplate: "Edit WhatsApp Template",
      whatsappBody: "WhatsApp message text (EN)",
      whatsappBodyAr: "WhatsApp message text (AR)",
      whatsappBodyHint: "WhatsApp messages are plain text with no subject. Avoid HTML tags.",
      statisticsTab: "Statistics",
      couponsTab: "Coupons",
      cronTab: "CRON Jobs",
      cartsTab: "Carts",
      enableExtension: "Enable Extension",
      dateFormatLabel: "Date Format",
      bccEmail: "BCC Email (Admin Copy)",
      bccEmailPlaceholder: "admin@store.com",
      removeExpiredCoupons: "Remove Expired Coupons",
      settingsSaved: "Settings saved successfully",
      settingsFailed: "Failed to save settings",
      templateName: "Template Name (EN)",
      templateNameAr: "Template Name (AR)",
      templateSubject: "Email Subject (EN)",
      templateSubjectAr: "Email Subject (AR)",
      templateBody: "Email Body EN (HTML)",
      templateBodyAr: "Email Body (AR)",
      delayHours: "Send After (Hours)",
      discountType: "Discount Type",
      discountNone: "No Discount",
      discountPercentage: "Percentage",
      discountFixed: "Fixed Amount",
      discountValue: "Discount Value",
      discountExpiryDays: "Coupon Expiry (Days)",
      customerGroups: "Target Customers",
      allCustomers: "All Customers",
      registeredOnly: "Registered Only",
      guestsOnly: "Guests Only",
      templateChannel: "Channel",
      addTemplate: "Add Template",
      editTemplate: "Edit Template",
      templateSaved: "Template saved",
      templateDeleted: "Template deleted",
      noTemplates: "No message templates yet. Create an Email or WhatsApp template to automate cart recovery reminders.",
      templateVarsHelp: "Variables: {firstname}, {fullname}, {email}, {phone}, {total_amount}, {item_count}, {discount_code}, {store_name}, {currency}, {currency_symbol}, {cart_url}",
      templateVarsToolbarTitle: "Available variables",
      templateVarsToolbarHint: "Click a variable to insert it; click the copy icon to copy it",
      templateVarsInsertHint: "Insert into message",
      templateVarsCopyHint: "Copy variable",
      templatePreviewTitle: "Live preview (sample values, store currency)",
      messageTemplatesTitle: "Message templates (WhatsApp / Email)",
      messageTemplatesDesc: "Edit the wording of abandoned cart reminder messages.",
      messageTemplatesHint: "Amounts automatically use the store currency configured in general settings.",
      cronEnabled: "Enable Automated Reminders",
      cronInterval: "Check Interval (minutes)",
      cronMaxEmails: "Max Emails per Batch",
      cronSchedule: "CRON Schedule",
      runNow: "Run Now",
      cronProcessed: "reminders processed",
      cronTip: "When enabled, the system automatically sends reminders based on your mail templates schedule.",
      registeredVsGuests: "Registered vs Guests",
      registered: "Registered",
      guests: "Guests",
      topExitPages: "Top Exit Pages",
      pageUrl: "Page URL",
      exitCount: "Count",
      totalReminded: "Total Reminded",
      couponCode: "Coupon Code",
      couponDiscount: "Discount",
      couponExpires: "Expires",
      couponUsed: "Used",
      couponNotUsed: "Not Used",
      couponsTabDesc: "These coupons are auto-generated by the reminder system for each abandoned cart, tied to a template that has a percentage or fixed discount. They are NOT your general marketing coupons (those live under Marketing › Coupons).",
      noCoupons: "No coupons generated yet",
      noCouponsHint: "Codes will appear here automatically the first time a reminder is sent using a template that has a discount. To create manual marketing coupons for campaigns, go to Marketing › Coupons.",
      totalCoupons: "Total Coupons",
      usedCoupons: "Used Coupons",
      ipAddress: "IP Address",
      lastPage: "Last Page Visited",
      firstVisit: "First Visit",
      lastVisit: "Last Visit",
      deleteCart: "Delete",
    },
    layouts: {
      title: "Layouts",
      subtitle: "Manage page layouts and module positions",
      addLayout: "Add Layout",
      editLayout: "Edit Layout",
      name: "Layout Name",
      nameAr: "Layout Name (Arabic)",
      route: "Route Pattern",
      saved: "Layout saved successfully",
      deleted: "Layout deleted",
      modulesCount: "modules",
      manageModules: "Modules",
      modulesSaved: "Modules updated",
      noModulesAssigned: "No modules assigned to this layout",
      addModule: "Add Module",
      contentTop: "Content Top",
      contentBottom: "Content Bottom",
      columnLeft: "Column Left",
      columnRight: "Column Right",
    },
    modules: {
      title: "Modules",
      subtitle: "Create and manage display modules for layouts",
      addModule: "Add Module",
      editModule: "Edit Module",
      name: "Module Name",
      nameAr: "Module Name (Arabic)",
      type: "Module Type",
      saved: "Module saved successfully",
      deleted: "Module deleted",
      moduleTitle: "Title",
      moduleTitleAr: "Title (Arabic)",
      typeHtml: "HTML Block",
      typeBanner: "Banner",
      typeSlider: "Slider",
      typeProductGrid: "Product Grid",
      typeFeatured: "Featured Products",
      typeLatest: "Latest Products",
      htmlContent: "HTML Content",
      htmlContentAr: "HTML Content (Arabic)",
      imageUrl: "Image URL",
      linkUrl: "Link URL",
      autoplay: "Autoplay",
      interval: "Interval (ms)",
      limit: "Products Limit",
      columns: "Columns",
    },
    productExtras: {
      title: "Product Extras",
      subtitle: "Manage product labels and custom tabs",
      labelsTab: "Labels",
      tabsTab: "Custom Tabs",
      labelsDesc: "Create badges and labels to highlight products",
      tabsDesc: "Add custom information tabs to product pages",
      addLabel: "Add Label",
      editLabel: "Edit Label",
      labelSaved: "Label saved",
      labelDeleted: "Label deleted",
      noLabels: "No labels created yet",
      labelName: "Label Name",
      labelNameAr: "Label Name (Arabic)",
      labelText: "Display Text",
      labelTextAr: "Display Text (Arabic)",
      bgColor: "Background Color",
      textColorLabel: "Text Color",
      position: "Position",
      posTopRight: "Top Right",
      posTopLeft: "Top Left",
      posBottomRight: "Bottom Right",
      posBottomLeft: "Bottom Left",
      products: "Products",
      addTab: "Add Tab",
      editTab: "Edit Tab",
      tabSaved: "Tab saved",
      tabDeleted: "Tab deleted",
      noTabs: "No custom tabs created yet",
      tabName: "Tab Name",
      tabNameAr: "Tab Name (Arabic)",
      tabContent: "Content",
      tabContentAr: "Content (Arabic)",
      applyTo: "Apply To",
      applyAll: "All Products",
      applyProducts: "Specific Products",
      applyCategories: "Specific Categories",
      sortOrder: "Sort Order",
    },
    seoEditor: {
      title: "SEO Editor",
      subtitle: "Edit SEO data for all pages in one place",
      entityName: "Item",
      entityType: "Type",
      metaTitle: "Meta Title",
      metaDescription: "Meta Description",
      metaKeywords: "Meta Keywords",
      urlKeyword: "URL Keyword",
      saveChanges: "Save Changes",
      saved: "SEO data saved",
      noChanges: "No changes to save",
      filterType: "Filter by type",
      allTypes: "All Types",
      product: "Product",
      category: "Category",
      brand: "Brand",
      page: "Page",
      blogPost: "Blog Post",
      modified: "Modified",
      searchPlaceholder: "Search by name, URL keyword or meta title (AR or EN)...",
      showingResults: "Showing {from}-{to} of {total}",
      previous: "Previous",
      next: "Next",
      pageOf: "Page {current} of {total}",
      english: "English",
      arabic: "Arabic",
      enPlaceholder: "English…",
      arPlaceholder: "بالعربية…",
      statusFilter: "Status",
      statusAll: "All",
      statusMissing: "Missing meta",
      statusPartial: "Only one language",
      statusComplete: "Complete (AR + EN)",
      saveFailed: "Save failed",
    },
    advancedStyles: {
      title: "Advanced Styles",
      subtitle: "Customize element-specific styles across your store",
      buttons: "Button Styles",
      buttonsDesc: "Customize button appearance",
      primaryBtnBg: "Primary Button Background",
      primaryBtnText: "Primary Button Text",
      primaryBtnRadius: "Primary Button Radius",
      secondaryBtnBg: "Secondary Button Background",
      secondaryBtnText: "Secondary Button Text",
      menus: "Menu Styles",
      menusDesc: "Customize navigation menus",
      menuBg: "Menu Background",
      menuText: "Menu Text Color",
      menuHover: "Menu Hover Color",
      menuFontSize: "Menu Font Size",
      typography: "Typography",
      typographyDesc: "Customize text and link styles",
      headingFont: "Heading Font",
      bodyFont: "Body Font",
      linkColor: "Link Color",
      linkHoverColor: "Link Hover Color",
      badges: "Badge Styles",
      badgesDesc: "Customize badge and tag appearance",
      saleBadgeBg: "Sale Badge Background",
      saleBadgeText: "Sale Badge Text",
      newBadgeBg: "New Badge Background",
      newBadgeText: "New Badge Text",
      saved: "Styles saved successfully",
    },
    warehouses: {
      title: "Warehouses",
      subtitle: "Manage multi-source inventory locations",
      addWarehouse: "Add Warehouse",
      editWarehouse: "Edit Warehouse",
      name: "Warehouse Name",
      nameAr: "Name (Arabic)",
      code: "Code",
      address: "Address",
      city: "City",
      country: "Country",
      phone: "Phone",
      email: "Email",
      priority: "Priority",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      products: "Products",
      totalStock: "Total Stock",
      stockManagement: "Stock Management",
      quantity: "Quantity",
      updateStock: "Update Stock",
      transfer: "Transfer Stock",
      fromWarehouse: "From Warehouse",
      toWarehouse: "To Warehouse",
      selectProduct: "Select a product",
      searchByNameOrSku: "Search by name or SKU…",
      selectFromWarehouseFirst: "Select source warehouse first",
      noProductsInWarehouse: "No products in this warehouse",
      noMatchingProducts: "No matching products",
      available: "available",
      transferHistory: "Transfer History",
      noWarehouses: "No warehouses yet",
      saved: "Warehouse saved successfully",
      deleted: "Warehouse deleted",
      transferSuccess: "Stock transferred successfully",
      seedFromProducts: "Seed Stock from Products",
      seedConfirm: "This copies every product's current quantity into the selected warehouse and removes orphaned rows. Continue?",
      seedNoTarget: "Choose a target warehouse first",
      seedSuccess: "Initialization completed",
    },
    b2b: {
      title: "B2B Commerce",
      companies: "Companies",
      companiesSubtitle: "Manage B2B company accounts",
      addCompany: "Add Company",
      editCompany: "Edit Company",
      companyName: "Company Name",
      nameAr: "Name (Arabic)",
      email: "Email",
      phone: "Phone",
      taxId: "Tax ID",
      address: "Address",
      city: "City",
      country: "Country",
      industry: "Industry",
      creditLimit: "Credit Limit",
      paymentTerms: "Payment Terms",
      status: "Status",
      users: "Users",
      addUser: "Add User",
      role: "Role",
      buyer: "Buyer",
      manager: "Manager",
      admin: "Admin",
      canApprove: "Can Approve Orders",
      spendingLimit: "Spending Limit",
      search: "Search by company name or email...",
      noSearchResults: "No companies match your search",
      statTotal: "Total Companies",
      statActive: "Active Companies",
      statCredit: "Total Credit Limit",
      statUsers: "B2B Users",
      active: "Active",
      inactive: "Inactive",
      suspended: "Suspended",
      termImmediate: "Immediate",
      termNet15: "Net 15 days",
      termNet30: "Net 30 days",
      termNet60: "Net 60 days",
      termNet90: "Net 90 days",
      manageUsers: "Manage Users",
      noUsers: "No users linked to this company yet",
      confirmDelete: "Permanently delete this company?",
      contactInfo: "Contact Details",
      billingInfo: "Billing & Payment Terms",
      selectCustomer: "Select a customer to add",
      permissions: "Permissions",
      approveHint: "This user can approve company orders",
      viewQuotes: "Quotes",
      noCompanies: "No companies yet",
      saved: "Company saved successfully",
      deleted: "Company deleted",
      quotes: "Quotes",
      quotesSubtitle: "Manage B2B price quotes",
      addQuote: "Add Quote",
      editQuote: "Edit Quote",
      customerName: "Customer Name",
      customerEmail: "Customer Email",
      subtotal: "Subtotal",
      discount: "Discount",
      total: "Total",
      notes: "Notes",
      adminNotes: "Admin Notes",
      validUntil: "Valid Until",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      expired: "Expired",
      noQuotes: "No quotes yet",
      quoteSaved: "Quote saved successfully",
      quoteDeleted: "Quote deleted",
    },
    contentStaging: {
      title: "Content Staging",
      subtitle: "Schedule content publishing and unpublishing",
      publishAt: "Publish At",
      unpublishAt: "Unpublish At",
      entityType: "Content Type",
      product: "Product",
      banner: "Banner",
      category: "Category",
      scheduled: "Scheduled",
      process: "Process Now",
      processSuccess: "Staging processed: {published} published, {unpublished} unpublished",
      noScheduled: "No scheduled content",
      schedule: "Schedule",
      clearSchedule: "Clear Schedule",
      scheduleSaved: "Schedule saved successfully",
    },
    pricingRules: {
      title: "Pricing Rules",
      subtitle: "Advanced pricing rules and tiered pricing",
      addRule: "Add Rule",
      editRule: "Edit Rule",
      name: "Rule Name",
      nameAr: "Name (Arabic)",
      type: "Type",
      cartRule: "Cart Rule",
      catalogRule: "Catalog Rule",
      discountType: "Discount Type",
      percentage: "Percentage",
      fixedAmount: "Fixed Amount",
      buyXgetY: "Buy X Get Y",
      discountValue: "Discount Value",
      priority: "Priority",
      stopProcessing: "Stop Processing",
      customerGroup: "Customer Group",
      startDate: "Start Date",
      endDate: "End Date",
      usageLimit: "Usage Limit",
      usedCount: "Used Count",
      conditions: "Conditions",
      minCartTotal: "Min Cart Total",
      minQuantity: "Min Quantity",
      specificProducts: "Specific Products",
      specificCategories: "Specific Categories",
      noRules: "No pricing rules yet",
      saved: "Pricing rule saved successfully",
      deleted: "Pricing rule deleted",
      tieredPricing: "Tiered Pricing",
      minQty: "Min Qty",
      maxQty: "Max Qty",
      price: "Price",
      addTier: "Add Tier",
    },
    aiSearch: {
      title: "AI Search & Recommendations",
      subtitle: "Smart search with synonyms and personalized recommendations",
      synonyms: "Search Synonyms",
      addSynonym: "Add Synonym",
      keyword: "Keyword",
      synonymsList: "Synonyms (comma-separated)",
      noSynonyms: "No search synonyms yet",
      synonymSaved: "Synonym saved",
      synonymDeleted: "Synonym deleted",
      didYouMean: "Did you mean",
      trending: "Trending Products",
      recommended: "Recommended for You",
      similarProducts: "Similar Products",
    },
    inventory: {
      title: "Inventory Management",
      subtitle: "Complete stock management and inventory control",
      dashboard: "Dashboard",
      products: "Stock Levels",
      adjustments: "Stock Adjustments",
      history: "Movement History",
      counts: "Inventory Counts",
      alerts: "Stock Alerts",
      valuation: "Stock Valuation",
      suppliers: "Suppliers",
      totalProducts: "Tracked Products",
      totalUnits: "Total Units",
      costValue: "Cost Value",
      retailValue: "Retail Value",
      outOfStock: "Out of Stock",
      lowStock: "Low Stock",
      overstocked: "Overstocked",
      inStock: "In Stock",
      warehouses: "Warehouses",
      recentMovements: "Recent Stock Movements",
      topMovers: "Top Movers (30 Days)",
      stockByWarehouse: "Stock by Warehouse",
      search: "Search by name, SKU, or barcode...",
      allProducts: "All Products",
      filterLowStock: "Low Stock",
      filterOutOfStock: "Out of Stock",
      filterOverstocked: "Overstocked",
      filterBackorder: "Backorder",
      sku: "SKU",
      barcode: "Barcode",
      currentStock: "Current Stock",
      costPrice: "Cost Price",
      reorderPoint: "Reorder Point",
      reorderQty: "Reorder Qty",
      minStock: "Min Stock",
      maxStock: "Max Stock",
      trackInventory: "Track Inventory",
      allowBackorder: "Allow Backorder",
      locationLabel: "Storage Location",
      adjustStock: "Adjust Stock",
      quantity: "Quantity",
      reason: "Reason",
      reasonReceived: "Received / Purchase",
      reasonSold: "Sold",
      reasonReturned: "Customer Return",
      reasonDamaged: "Damaged / Defective",
      reasonLost: "Lost / Theft",
      reasonCorrection: "Manual Correction",
      reasonTransfer: "Warehouse Transfer",
      reasonPromotion: "Promotional Use",
      reference: "Reference #",
      notes: "Notes",
      increase: "Increase (+)",
      decrease: "Decrease (-)",
      adjustmentSuccess: "Stock adjusted successfully",
      bulkAdjust: "Bulk Adjust",
      movementType: "Type",
      before: "Before",
      after: "After",
      change: "Change",
      date: "Date",
      admin: "Admin",
      warehouse: "Warehouse",
      noHistory: "No stock movement history",
      newCount: "New Inventory Count",
      countName: "Count Name",
      startCount: "Start Count",
      completeCount: "Complete Count",
      applyCount: "Apply Adjustments",
      systemQty: "System Qty",
      countedQty: "Counted Qty",
      variance: "Variance",
      noCounts: "No inventory counts yet",
      countCreated: "Inventory count created",
      countApplied: "Inventory count adjustments applied",
      draft: "Draft",
      inProgress: "In Progress",
      completed: "Completed",
      applied: "Applied",
      lowStockAlert: "Low Stock Alert",
      outOfStockAlert: "Out of Stock Alert",
      overstockedAlert: "Overstocked Alert",
      noAlerts: "No stock alerts",
      needsReorder: "Needs Reorder",
      backorderEnabled: "Backorder Enabled",
      supplierName: "Supplier Name",
      supplierEmail: "Email",
      supplierPhone: "Phone",
      supplierSku: "Supplier SKU",
      leadTime: "Lead Time (days)",
      minOrder: "Min Order Qty",
      primarySupplier: "Primary Supplier",
      addSupplier: "Add Supplier",
      noSuppliers: "No suppliers configured",
      totalCostValue: "Total Cost Value",
      totalRetailValue: "Total Retail Value",
      potentialProfit: "Potential Profit",
      marginPercent: "Margin %",
      exportReport: "Export Report",
      product: "Product",
      category: "Category",
      stockStatus: "Stock Status",
      actions: "Actions",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      confirm: "Confirm",
      saved: "Saved successfully",
      deleted: "Deleted successfully",
      saveFailed: "Save failed",
      refresh: "Refresh",
      // ===== Multi-type inventory (Phase 8) =====
      stockTypes: "Stock Types",
      procurement: "Procurement",
      selectProductForBreakdown: "Pick a product on the left to view its three stock pools",
      totalSellable: "Total sellable",
      ownedCostValue: "Owned stock value",
      depletionStrategy: "Depletion strategy",
      depletionStrategyDesc: "Order in which pools are consumed on a sale — directly impacts margin",
      strategies: {
        consignment_first: "Consignment first (max margin)",
        physical_first: "Physical first",
        physical_only: "Physical only",
        on_demand_only: "On-demand only (drop-ship)",
      },
      physicalStock: "Physical stock",
      physicalStockDesc: "Owned units in your warehouse — deducted on sale, valued at cost",
      editPhysicalHint: "Edit via the Adjustments tab",
      consignmentStock: "Consignment stock",
      consignmentStockDesc: "Held in your warehouse but owned by a supplier — zero cost to you, settled with the owner after sale",
      consignmentOwner: "Owner (supplier)",
      onDemandStock: "On-demand stock (drop-ship)",
      onDemandStockDesc: "Virtual capacity — selling a unit creates a procurement request and does NOT decrement stock",
      virtualCapacity: "Virtual capacity",
      onDemandHint: "Note: a sale here does not decrement the count — it creates a new procurement request in the Procurement tab.",
      noSupplier: "No supplier",
      // Procurement
      allStatuses: "All statuses",
      procurementStatus: {
        pending: "Pending",
        ordered: "Ordered",
        received: "Received",
        fulfilled: "Fulfilled",
        cancelled: "Cancelled",
      },
      noProcurementRequests: "No procurement requests",
      unitCost: "Unit cost",
      unitCostPrompt: "Enter unit cost from supplier:",
      expectedAt: "Expected",
      markOrdered: "Mark as ordered",
      markReceived: "Mark as received",
      markFulfilled: "Mark as fulfilled",
    },
  },
};

export default en;
export type Translations = typeof en;
